import React, { Fragment, useState, useEffect, useRef, useMemo } from 'react';
import * as Yup from 'yup';
import { withFormik, FieldArray } from 'formik';
import DeleteIcon from '../../../Assets/General/DeleteIcon';
import AddContact from '../../../Pages/Contact/AddContact';
import { Draggable } from 'react-beautiful-dnd';
import { MdHelpOutline } from '../../../Common/Icons';
import { GoArrowSwitch } from 'react-icons/go';
import AddCurrency from '../../../Pages/Currency/AddCurrency';

import {
  required,
  ValidateDate,
  ValidateMax15,
  ValidateMax50,
  ValidateMax255,
  ValidateMax100Number,
  ValidateMax10Billion,
  moreThanZero,
  moreThanMinus,
  ValidateAmountNumber,
  ValidateRequired,
  MAX_NUMBER,
  // MAX_NUMBER_MESSAGE,
  ValidateNumber,
  ValidateEqual0,
  ValidateMax1000,
} from '../../../Helpers/Validator';
import {
  getOverallTaxDetails,
  getFilteredItem,
  handleExtraDescription,
  checkError,
  getItemTotalAmount,
  getOrganizationDate,
  pageIdentify,
  restRequest,
  getObjFromLS,
  setObjInLS,
  confirmationAlert,
  GetDateString,
} from '../../../Helpers';
import {
  ItemForm,
  Field,
  Form,
  FormAction,
  BulkAddItems,
  ErrorFocus,
  AddItem,
  BulkAddConfirmedSalesOrders,
} from '../';
import { CustomModal, Radio, RadioContainer, Loader } from '../../';
import PDFViewer from '../../PDFViewer/PDFViewer';
import Switch from './../../Switch/Switch';
import { getError, validate, formSubmit } from '../FormHelper';
import {
  prepareConfirmedSalesOrdersItems,
  toTwoDecimal,
} from '../../../Api/Invoice/Utils';
import InvoiceTerm from '../../../Pages/SalesOrder/Invoices/InvoiceTerms/InvoiceTerm';
import InvoiceTermUpdate from '../../../Pages/SalesOrder/Invoices/InvoiceTerms/InvoiceTermUpdate';
import ListTableImageColumn from '../../ListTable/ListTableImageColumn';
import { getDiscountOptions } from '../../../Constants';
import { ranges, customRanges } from '../../CustomDatePicker/StaticRanges';
import moment from 'moment/moment';
import { addDays } from 'date-fns';
import {
  NewItemIcon,
  NewSalesOrderIcon,
} from '../../../Assets/Navigation/NavigationIcons';
import Customer from '../../../Pages/Contact/ContactDetails/index';
import {
  NewContactIcon,
  NewInvoiceIcon,
} from '../../../Assets/Navigation/NavigationIcons';
import { validateInvoiceForm } from '../../../Helpers/FormValidator';
import { MdDragIndicator } from '../../../Common/Icons';
import DragDropItems from '../../../Common/DragDrop';
import { prepareItemsList } from '../../../Api/Invoice/Utils';
import { ToolTip } from '../../../Common';
import TableContent from '../../ListTable/TableContant';
import { t } from 'i18next';
import { debounce } from 'lodash';

let totalConfirmCheck = false;
let confirmModal = false;
const getYupValidationSchema = (values, rest) => {
  const t = rest?.t;
  return Yup.object().shape({
    customerId: required(ValidateNumber),
    invoiceNo: required(ValidateMax50),
    invoiceDate: required(ValidateDate),
    orderNo: ValidateMax15,
    note: ValidateMax255.nullable(),
    items: Yup.array()
      .of(
        Yup.lazy((item) => {
          return Yup.object().shape({
            name: ValidateRequired,
            quantity: required(
              moreThanZero(ValidateMax10Billion).integer(
                t('common.validation.invalidValue')
              )
            ),
            unitPrice: required(
              moreThanMinus(
                ValidateMax10Billion.transform((value, originalValue) => {
                  return originalValue === '' || isNaN(originalValue)
                    ? null
                    : value;
                })
              )
            ),
            discount:
              item.discountType === 'percent'
                ? ValidateMax100Number
                : ValidateAmountNumber(
                  item.discount,
                  item.quantity * item.unitPrice
                ),
          });
        })
      )
      .min(1, t('common.validation.atLeastOneItem')),
    adjustment: ValidateMax10Billion,
    shippingCharge: ValidateMax10Billion,
    termsAndConditions: values.hasTermsAndConditions
      ? ValidateMax1000.nullable()
      : ValidateEqual0.nullable(),
    //transactionDiscount: values.transactionDiscountType === 'amount' ? ValidateMax10Billion : ValidateMax100Number
    transactionDiscount:
      values.transactionDiscountType === 'percent'
        ? ValidateMax100Number
        : ValidateMax10Billion,
    edit_reason: Yup.string().max(1000, t('common.validation.reasonMax1000')), // Add a max length validation
    // .required('Reason for editing is required'), // Ensure it's required if needed
  });
};
// let totalItems = 0;
let direcInvItems = [];
const formEnhancer = withFormik({
  enableReinitialize: true, // ✅ ensures values update when props change

  validate: validate(getYupValidationSchema),
  mapPropsToValues: ({ invoice, exchangeRate }) => {
    return {
      ...invoice,
      exchangeRate: exchangeRate || 1,
      orderNo: invoice.orderNo ? invoice.orderNo : '',
      // unitPrice:i
      salesPersonId: Number(invoice?.salesPersonId) || null,

    };
  },
  mapPropsToStatus: (props) => {
    return ({
      emptyItem: props.emptyItem,
      itemsList: props.itemsList,
      disableDate: props.disableDate,
      confirmedSalesOrdersList: props.confirmedSalesOrdersList,
      showConfirmedSalesOrdersListModal: false,
      showContactCreateModal: false,
      showItemModal: false,
      showTermsModal: false,
      selectedConfirmedSalesOrderIds: [],
      formTitle: props.title,
      salesOrderId: props.salesOrderId || null,
      showAddItemButton: props.showAddItemButton || true,
      globalCurrency: props.currency,
    });
  },
  handleSubmit: (values, bag) => {
    handleFormSubmit(values, bag);
  },
});
const handleFormSubmit = (
  values,
  {
    setSubmitting,
    props: {
      id,
      submitRequestType,
      submitRequestUrl,
      successMessage,
      discountPreference,
      inModal,
      close,
      onSubmit,
      history,
      type,
      warehousesList,
      handleToast,
      handleTotalCheckTrue,
      confirmOnEdit,
      handleReasonOnEdit,
      handleTotalCheckFalse,
      setPrompt,
      show_sales_person_all_records,
      owner_can_edit_in_lock_status,
      t,
    },
  }
) => {
  const total = getOrderTotal(values, values.overAllTotalTaxInValues);
  const overAllTotalTax = () => {
    let overallTax = getOverallTaxDetails(values.items);
    let TotalTax = 0;
    overallTax.forEach((tax) => {
      TotalTax = TotalTax + tax.total;
    });
    return TotalTax;
  };
  if (
    owner_can_edit_in_lock_status &&
    !confirmModal &&
    values?.status !== 'draft'
  ) {
    handleReasonOnEdit(true);
    setSubmitting(false);
    return;
  }

  if (parseFloat(total) === 0 && !totalConfirmCheck) {
    handleTotalCheckTrue(true);
    setSubmitting(false);
    return;
  }
  if (getOrderTotal(values, values.overAllTotalTaxInValues) >= MAX_NUMBER) {
    // handleToast(`Total must be ${MAX_NUMBER_MESSAGE}`, 'error');
    // setSubmitting(false);
    // return;
  } else if (
    getOrderTotal(values, values.overAllTotalTaxInValues) === 'MAX_AMOUNT'
  ) {
    handleToast(t('Invoice.discount_less_than_total'), 'error');
    setSubmitting(false);
    return;
  } else if (
    getOrderTotal(values, values.overAllTotalTaxInValues) === 'MAX_PERCENTAGE'
  ) {
    handleToast(t('Invoice.discount_less_than_100'), 'error');
    setSubmitting(false);
    return;
  }

  let discountLevel = values.discountLevel;

  if (!discountLevel) {
    if (discountPreference.at_individual_item_level) {
      discountLevel = 'item';
    }
    if (discountPreference.at_transaction_level) {
      discountLevel = 'transaction';
    }
  }

  let inActiveWarehouse = values.items.some((item) => {
    return warehousesList.find(
      (list) => list.is_active === 0 && list.id === item.warehouseId
    );
  });
  if (inActiveWarehouse === true) {
    setSubmitting(false);
    return handleToast(t('Invoice.cannot_use_inactive_warehouse'), 'error');
  }

  let payload = {
    invoice_no: values.invoiceNo,
    order_no: values.orderNo,
    exchange_rate: values.exchangeRate || 1,
    currency_id: values.globalCurrency,
    customer_id: values.customerId,
    invoice_term_name: values.invoiceTerm.name,
    invoice_term_value: values.invoiceTerm.value,
    edit_reason: values?.edit_reason || null,
    invoice_date: values.invoiceDate
      ? values.invoiceDate.format('YYYY-MM-DD 00:00:00')
      : null,
    due_date: values.dueDate
      ? values.dueDate.format('YYYY-MM-DD 23:59:59')
      : null,
    note: values.note,
    items: values.items.map((item, index) => ({
      id: item.id,
      sort_order: index,
      sales_order_item_detail_id: item.salesOrderItemDetailId,
      invoice_item_detail_id: item.invoiceItemDetailId || null,
      warehouse_id: item.warehouseId,
      name: item.name,
      quantity: item.quantity || 0,
      rate: parseFloat(item.unitPrice) || 0,
      unit: item.unit,
      tax_id: item?.tax?.id,
      extra_description: item.extra_description,
      discount_item_level: item.discount || 0,
      discount_type: item.discountType,
      sales_unit_price: item.sales_unit_price,
      baseCurrencyValue: item.baseCurrencyValue,
    })),
    adjustment: parseFloat(values.adjustment)?.toFixed(2) || 0,
    base_adjustment: values.baseAdjustment || 0,
    shipping_charge: parseFloat(values.shippingCharge)?.toFixed(2) || 0,
    base_shipping_charge: values.baseShippingCharge || 0,
    discount_transaction_level:
      parseFloat(values.transactionDiscount)?.toFixed(2) || 0,
    discount_type: values.transactionDiscountType,
    //discount_level: discountLevel,
    discount_level: discountLevel === 'no_discount' ? '' : discountLevel,
    sales_person_id: values.salesPersonId,
    terms_and_condition: values.hasTermsAndConditions
      ? values.termsAndConditions
      : '',
    total: !isNaN(getOrderTotal(values, overAllTotalTax))
      ? parseFloat(getOrderTotal(values, overAllTotalTax))?.toFixed(2)
      : 0.0,
  };

  restRequest(submitRequestType(), submitRequestUrl(), payload)
    .then((res) => {
      setPrompt(false);
      successMessage();
      totalConfirmCheck = false;
      confirmModal = false;
      handleTotalCheckFalse(false);
      let dataFromLS = getObjFromLS('module');
      if (dataFromLS === null) {
        let obj = {
          prevId: null,
          id: null,
          nextId: null,
          moduleName: 'invoices',
          urlPath: '/invoices',
          queryParam: window.location.search,
        };
        setObjInLS('module', obj);
        dataFromLS = getObjFromLS('module');
        return history.push('/r');
      }
      if (values.saveAndSend) {
        // let dataFromLS = getObjFromLS('module')
        // setObjInLS('module',{...dataFromLS ,moduleName: 'invoices', action: type ==='add' ? 'add' : 'justedit' , queryParam :"", urlPath: type ==='add' ? '/invoices' :dataFromLS.urlPath})
        if (type === 'add') {
          if (inModal && window.location.pathname.includes('salesorders')) {
            setObjInLS('module', {
              ...dataFromLS,
              moduleName: 'salesorders',
              urlPath: window.location.pathname,
              queryParam: `${dataFromLS.queryParam ? dataFromLS.queryParam + '&' : '?'
                }invoices=true`,
            });
          } else {
            setObjInLS('module', {
              ...dataFromLS,
              moduleName: 'invoices',
              id: res.data.id,
              action: type === 'add' ? 'add' : 'justedit',
              queryParam: '',
            });
          }
          sessionStorage.setItem('fullscreen', false);
        } else if (type === 'clone') {
          setObjInLS('module', {
            ...dataFromLS,
            moduleName: 'invoices',
            id: res.data.id,
            action: 'add',
            queryParam: '',
          });
          sessionStorage.setItem('fullscreen', false);
        } else if (type === 'edit') {
          setObjInLS('module', {
            ...dataFromLS,
            action: type === 'add' ? 'add' : 'justedit',
            queryParam: dataFromLS.queryParam ? dataFromLS.queryParam : '',
          });
        }
        history.push(`/invoices/email/${id ? id : res.data.id}`);
      } else if (inModal && !pageIdentify(window.location.pathname)) {
        // let dataFromLS = getObjFromLS('module')
        setObjInLS('module', {
          ...dataFromLS,
          queryParam: `${dataFromLS.queryParam ? dataFromLS.queryParam + '&' : '?'
            }invoices=true`,
        });
        return history.push('/r');
      } else if (inModal) {
        // close()
        // onSubmit()
        // let dataFromLS = getObjFromLS('module')
        setObjInLS('module', {
          ...dataFromLS,
          moduleName: 'invoices',
          queryParam: `${dataFromLS.queryParam ? dataFromLS.queryParam + '&' : '?'
            }invoices=true`,
        });
        // return history.push('/r');
        return history.go();
      } else {
        if (type === 'add') {
          setObjInLS('module', {
            ...dataFromLS,
            moduleName: 'invoices',
            urlPath: '/invoices',
            id: res.data.id,
            action: type === 'add' ? 'add' : 'justedit',
            queryParam: '',
          });
        } else if (type === 'clone') {
          setObjInLS('module', {
            ...dataFromLS,
            moduleName: 'invoices',
            urlPath: '/invoices',
            id: res.data.id,
            action: 'add',
            queryParam: '',
          });
        } else if (type === 'edit') {
          setObjInLS('module', {
            ...dataFromLS,
            action: type === 'add' ? 'add' : 'justedit',
            id: values.invoiceId,
            urlPath: '/invoices',
            queryParam: dataFromLS.queryParam ? dataFromLS.queryParam : '',
          });
        }
        history.push('/r');
        sessionStorage.setItem('fullscreen', false);
      }
    })
    .catch((error) => {
      confirmModal = false;
      checkError(error);
      handleToast(error, 'error');
      setSubmitting(false);
    });
};

const InvoiceForm = ({
  // props from formik
  values,
  status,
  handleSubmit,
  handleChange,
  handleBlur,
  setFieldValue,
  setStatus,
  setValues,
  isSubmitting,
  errors,
  touched,
  setFieldTouched,

  // custom props
  title,
  inModal,
  close,
  emptyItem,
  discountPreference,
  itemLevelIndvidual,
  currency,
  fetchTermsList,
  checkDirectInvoice,
  invoiceTermsList,
  taxList,
  contactIdTransaction,
  customersList,
  baseCurrencylist,
  type,
  invoice,
  invoiceItemsLength,
  warehousesList,
  salesPersonsFromDB,
  is_sales_person,
  sales_person_clearable,
  handleToast,
  history,
  previousPurchasePrices,
  salesOrderId,

  cofirmState,
  confirmOnEdit,
  handleReasonOnEdit,
  handleTotalCheckTrue,
  handleTotalCheckFalse,
  show_sales_person_all_records,
  owner_can_edit_in_lock_status,
  temporary_edit,
  t,
  ...props
}) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [staticVal, setStaticValues] = useState({});
  const [itemsList, setItemsList] = useState([]);
  const [terms_condition, setTerms_condition] = useState([]);
  const [CurrentCustomer, setCurrentCustomer] = useState({});
  const [currentCurrency, setCurrency] = useState();
  const [currencyList, setCurrencyList] = useState(baseCurrencylist || []);
  const [isSaleOrderSelected, setIsConfirmedSaleOrderSelected] =
    useState(false);
  const [showConfirmRemoveItemModal, setShowConfirmRemoveItemModal] =
    useState(false);
  const [showPDF, setShowPDF] = useState(false);
  const [pdf, setPdf] = useState(null);
  let permissions = getObjFromLS('role').permissions;

  const openInvoicePdf = () => {
    let discountLevel = values.discountLevel;
    if (!discountLevel) {
      if (discountPreference.at_individual_item_level) {
        discountLevel = 'item';
      }
      if (discountPreference.at_transaction_level) {
        discountLevel = 'transaction';
      }
    }

    const payload = {
      invoice_no: values.invoiceNo,
      order_no: values.orderNo,
      exchange_rate: values.exchangeRate || 1,
      currency_id: values.globalCurrency,
      customer_id: values.customerId,
      invoice_term_name: values.invoiceTerm.name,
      invoice_term_value: values.invoiceTerm.value,
      edit_reason: values?.edit_reason || null,
      invoice_date: values.invoiceDate
        ? values.invoiceDate.format('YYYY-MM-DD 00:00:00')
        : null,
      due_date: values.dueDate
        ? values.dueDate.format('YYYY-MM-DD 23:59:59')
        : null,
      note: values.note,
      items: values.items.map((item, index) => ({
        id: item.id,
        sort_order: index,
        sales_order_item_detail_id: item.salesOrderItemDetailId,
        invoice_item_detail_id: item.invoiceItemDetailId || null,
        warehouse_id: item.warehouseId,
        name: item.name,
        quantity: item.quantity || 0,
        rate: parseFloat(item.unitPrice) || 0,
        unit: item.unit,
        tax_id: item?.tax?.id,
        extra_description: item.extra_description,
        discount_item_level: item.discount || 0,
        discount_type: item.discountType,
        sales_unit_price: item.sales_unit_price,
        baseCurrencyValue: item.baseCurrencyValue,
      })),
      adjustment: parseFloat(values.adjustment)?.toFixed(2) || 0,
      base_adjustment: values.baseAdjustment || 0,
      shipping_charge: parseFloat(values.shippingCharge)?.toFixed(2) || 0,
      base_shipping_charge: values.baseShippingCharge || 0,
      discount_transaction_level:
        parseFloat(values.transactionDiscount)?.toFixed(2) || 0,
      discount_type: values.transactionDiscountType,
      discount_level: discountLevel === 'no_discount' ? '' : discountLevel,
      sales_person_id: values.salesPersonId,
      terms_and_condition: values.hasTermsAndConditions
        ? values.termsAndConditions
        : '',
      total: !isNaN(getOrderTotal(values, overAllTotalTax))
        ? parseFloat(getOrderTotal(values, overAllTotalTax))?.toFixed(2)
        : 0.0,
    };

    setShowPDF(true);
    restRequest(
      'post',
      `invoices/${values.invoiceId}/temporary-pdf`,
      payload
    )
      .then((res) => {
        setPdf(res);
      })
      .catch((error) => checkError(error, handleToast));
  };

  const hidePDFModal = () => {
    setShowPDF(false);
    setPdf(null);
  };

  useEffect(() => {
    handleAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, staticVal]);
  useEffect(() => {
    const selected =
      status?.confirmedSalesOrdersList.filter(
        (item) => item?.selectedByItem == true
      ).length > 0
        ? true
        : false;
    setIsConfirmedSaleOrderSelected(selected);
  }, [status?.confirmedSalesOrdersList]);
  const handleCurrencyCreateSubmit = async (currency) => {
    const newCurrencyOption = {
      value: currency.id,
      label: `${currency.currency_code} - ${currency.symbol} - ${currency.name}`,
      exchange_rate: currency.exchange_rate, // if available
    };
    setCurrencyList((prevList) => [
      ...prevList,
      {
        ...currency,
        value: currency.id,
        label: `${currency.currency_code} - ${currency.symbol} - ${currency.name}`,
        exchange_rate: currency.exchange_rate, // optional
        previous_exchange_rate: 0,
      },
    ]);
    // baseCurrencylist.push(newCurrencyOption);

    // setCurrency(newCurrencyOption)

    // setFieldValue("globalCurrency", newCurrencyOption.value);
    // setFieldValue("exchangeRate", currency.exchange_rate || 1);

    // // 3️⃣ Optionally update other form values if needed
    setValues({
      ...values,
      globalCurrency: newCurrencyOption.value,
      exchangeRate: currency.exchange_rate || 1,
      // currency_id: newCurrencyOption.value,
    });

    // 4️⃣ Close the modal
    // setStatus((prev) => ({
    //   ...prev,
    //   showCurrencyCreateModal: false,
    // }));
  };
  useEffect(() => {
    const currency = currencyList.find(
      (item) => item.id === values?.globalCurrency
    );
    setCurrency(currency);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.globalCurrency]);

  useEffect(() => {
    if (props.itemsList.length) {
      setFieldValue('items', props.itemsList);
      setItemsList(props.itemsList);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    let value = { ...values };
    delete value.overAllTotalTaxInValues;
    setStaticValues(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      direcInvItems = [];
    };
  }, []);

  const isManualChange = useRef(false);
  const previousCurrency = useRef(null);
  const previousExchangeRate = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    // Initialize refs on first render
    if (!isInitialized.current) {
      previousCurrency.current = values.globalCurrency;
      previousExchangeRate.current = values.exchangeRate;
      isInitialized.current = true;
      return;
    }

    // Check if currency or exchange rate changed BEFORE checking isManualChange
    const currencyChanged = previousCurrency.current !== values.globalCurrency;
    const exchangeRateChanged =
      previousExchangeRate.current !== values.exchangeRate;

    // If manual change flag is set, clear it but DON'T skip if currency/rate changed
    if (isManualChange.current) {
      isManualChange.current = false;
      // Only skip if there's no currency/rate change
      if (!currencyChanged && !exchangeRateChanged) {
        return;
      }
    }

    if (!currencyChanged && !exchangeRateChanged) {
      return;
    }

    // Get the selected currency object from baseCurrencylist
    const selectedCurrency = baseCurrencylist.find(
      (item) => item.id === values.globalCurrency
    );

    // Check if we're currently in base currency
    const isCurrentlyBaseCurrency =
      selectedCurrency && selectedCurrency.is_base_currency;

    // Update items with currency conversion
    const updatedItems = values.items.map((item, index) => {
      // Determine baseCurrencyValue - ALWAYS preserve if it exists
      let baseCurrencyValue;
      let baseDiscountValue = item.baseDiscountValue;
      let discount = item.discount;

      if (
        item.baseCurrencyValue !== undefined &&
        item.baseCurrencyValue !== null
      ) {
        // Already have base value stored - ALWAYS use it, never recalculate
        baseCurrencyValue = item.baseCurrencyValue;
      } else {
        // First time - check if previous currency was base currency
        const prevCurrency = baseCurrencylist.find(
          (curr) => curr.id === previousCurrency.current
        );

        if (prevCurrency && prevCurrency.is_base_currency) {
          // Previous was base currency, so unitPrice IS the base value
          baseCurrencyValue = item.unitPrice;
        } else {
          // Previous was foreign currency, calculate base value
          baseCurrencyValue =
            previousExchangeRate.current > 0
              ? item.unitPrice / previousExchangeRate.current
              : item.unitPrice;
        }
      }

      // Handle discount conversion if it's an amount (not percentage)
      if (item.discountType !== 'percent' && item.discount > 0) {
        if (item.baseDiscountValue === undefined) {
          // If we don't have a base discount value yet, calculate it
          const prevCurrency = baseCurrencylist.find(
            (curr) => curr.id === previousCurrency.current
          );

          if (prevCurrency && prevCurrency.is_base_currency) {
            // Previous was base currency, so discount IS the base value
            baseDiscountValue = item.discount;
          } else {
            // Previous was foreign currency, calculate base value
            baseDiscountValue =
              previousExchangeRate.current > 0
                ? item.discount / previousExchangeRate.current
                : item.discount;
          }
        }

        // Calculate new discount based on current exchange rate
        discount =
          values.exchangeRate > 0
            ? baseDiscountValue * values.exchangeRate
            : baseDiscountValue;
      }

      // Calculate new unitPrice - ALWAYS multiply baseCurrencyValue by exchange rate
      const baseCurrencyValueFixed = parseFloat(baseCurrencyValue);
      let newUnitPrice =
        values.exchangeRate > 0
          ? parseFloat(baseCurrencyValueFixed) * values.exchangeRate
          : parseFloat(baseCurrencyValueFixed);

      const updatedItem = {
        ...item,
        unitPrice: newUnitPrice,
        baseCurrencyValue: baseCurrencyValue, // Always preserve the base value
        discount: discount,
        baseDiscountValue: baseDiscountValue, // Preserve the base discount value
      };

      // Calculate total with updated item
      const total = parseFloat(getItemTotalAmount(updatedItem));
      return {
        ...updatedItem,
        total: total,
      };
    });

    // Handle adjustment conversion
    let baseAdjustment;
    if (values.baseAdjustment !== undefined) {
      baseAdjustment = values.baseAdjustment;
    } else {
      const prevCurrency = baseCurrencylist.find(
        (curr) => curr.id === previousCurrency.current
      );
      if (prevCurrency && prevCurrency.is_base_currency) {
        baseAdjustment = values.adjustment;
      } else {
        baseAdjustment =
          previousExchangeRate.current > 0
            ? values.adjustment / previousExchangeRate.current
            : values.adjustment;
      }
    }

    // Always multiply by exchange rate for ANY currency
    let newAdjustment =
      values.exchangeRate > 0
        ? baseAdjustment * values.exchangeRate
        : baseAdjustment;

    // Handle shippingCharge conversion
    let baseShippingCharge;
    if (values.baseShippingCharge !== undefined) {
      baseShippingCharge = values.baseShippingCharge;
    } else {
      const prevCurrency = baseCurrencylist.find(
        (curr) => curr.id === previousCurrency.current
      );
      if (prevCurrency && prevCurrency.is_base_currency) {
        baseShippingCharge = values.shippingCharge;
      } else {
        baseShippingCharge =
          previousExchangeRate.current > 0
            ? values.shippingCharge / previousExchangeRate.current
            : values.shippingCharge;
      }
    }

    // Handle transaction discount conversion
    let baseTransactionDiscount;
    if (values.baseTransactionDiscount !== undefined) {
      baseTransactionDiscount = values.baseTransactionDiscount;
    } else {
      const prevCurrency = baseCurrencylist.find(
        (curr) => curr.id === previousCurrency.current
      );
      if (prevCurrency && prevCurrency.is_base_currency) {
        baseTransactionDiscount = values.transactionDiscount || 0;
      } else {
        baseTransactionDiscount =
          previousExchangeRate.current > 0 && values.transactionDiscount
            ? values.transactionDiscount / previousExchangeRate.current
            : values.transactionDiscount || 0;
      }
    }

    // Always multiply by exchange rate for ANY currency
    let newShippingCharge =
      values.exchangeRate > 0
        ? baseShippingCharge * values.exchangeRate
        : baseShippingCharge;

    let newTransactionDiscount;
    if (values.transactionDiscountType === 'percent') {
      // For percentage, use the value directly
      newTransactionDiscount = values.transactionDiscount || 0;
    } else if (values.exchangeRate > 0) {
      // For amount with valid exchange rate, convert using the rate
      newTransactionDiscount = baseTransactionDiscount * values.exchangeRate;
    } else {
      // If no exchange rate, use baseTransactionDiscount directly
      newTransactionDiscount =
        baseTransactionDiscount || values.transactionDiscount || 0;
    }

    // Update all values
    setFieldValue('items', updatedItems);
    setFieldValue('adjustment', newAdjustment);
    setFieldValue('baseAdjustment', baseAdjustment);
    setFieldValue('shippingCharge', newShippingCharge);
    setFieldValue('baseShippingCharge', baseShippingCharge);
    setFieldValue('transactionDiscount', newTransactionDiscount);
    setFieldValue('baseTransactionDiscount', baseTransactionDiscount);

    // Update refs for next comparison
    previousCurrency.current = values.globalCurrency;
    previousExchangeRate.current = values.exchangeRate;
  }, [
    values?.globalCurrency,
    values?.exchangeRate,
    baseCurrencylist,
    setFieldValue,
  ]);

  useEffect(() => {
    const showButton = values.items.some((item) => item.id === null);
    setShowAddItemButton(!showButton);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.items?.length]);
  const handleAlert = () => {
    let value = { ...values };
    delete value.overAllTotalTaxInValues;
    let { checkout } = validateInvoiceForm(value, {
      ...staticVal,
      items: [emptyItem],
    });
    if (!checkout && !inModal) props.setPrompt();
    else if (!checkout && inModal) props.handlePrompt();
    else {
      if (inModal) props.handlePrompt(false);
      props.setPrompt(false);
    }
  };

  const getcurrencysymble = () => {
    const currency = currencyList.find(
      (item) => item.id === values.globalCurrency
    );

    return currency ? currency.symbol : null;
  };

  const getPreviousSoldCurrencySymbol = (id) => {
    const currency = currencyList.find((item) => item.id === id);
    return currency ? currency.symbol : null;
  };

  const handleInvoiceTerms = (option) => {
    if (option === null) {
      setStatus({
        ...status,
        disableDate: true,
      });
      setValues({
        ...values,
        invoiceTerm: {
          name: '',
          value: null,
        },
      });
      // let date = moment(getOrganizationDate());
      let date = values.invoiceDate;
      setFieldValue('dueDate', date);
    } else {
      let value = option.value;
      if (value === 'custom') {
        setStatus({
          ...status,
          disableDate: false,
        });
        setValues({
          ...values,
          invoiceTerm: {
            name: option.name,
            value: value,
          },
        });
      } else if (value === 'createNew') {
        setStatus({
          ...status,
          //disableDate: false,
          showTermsModal: true,
        });
        handlePrompt(false);
      } else {
        setStatus({
          ...status,
          disableDate: true,
        });
        setValues({
          ...values,
          invoiceTerm: {
            name: option.name,
            value: value,
          },
        });
      }
    }
  };

  let primaryWarehouse = null;
  warehousesList.forEach(function (warehouse) {
    if (warehouse.is_primary) {
      primaryWarehouse = warehouse.id;
    }
  });

  const handleDate = (option) => {
    let date = values.invoiceDate;
    if (option && option.value) {
      let value = option.value;
      switch (value) {
        case 'custom':
          break;
        case 'this month':
          date = moment(ranges().endOfMonth);
          break;
        case 'next month':
          date = moment(ranges().endOfNextMonth);
          break;
        case 'receipt':
          date = moment(ranges().endOfToday);
          break;
        default:
          date = moment(addDays(getOrganizationDate(), value));
      }
      setFieldValue('dueDate', date);
    } else {
      date = moment(getOrganizationDate());
      setFieldValue('dueDate', date);
    }
  };
  const getPreviousSellingPrice = async (
    contactId,
    item,
    status,
    setStatus
  ) => {
    // return item
    if (!contactId) {
      return item;
    } else {
      let updatedItem = [];
      setStatus({
        ...status,
        loadingItems: true,
      });

      let PPURL = `invoice/previoussoldprice`;
      const payload = {
        customer_id: contactId,
        item_id: item,
        object: 'invoice',
        object_id: type === 'edit' ? values.invoiceId : null,
      };

      await restRequest('post', PPURL, payload).then((previousPrice) => {
        updatedItem = previousPrice;
      });
      return updatedItem;
    }
  };
  const [loadingItem, setLoadingItem] = useState(false);
  const [confirmedSO, updateconfirmedSO] = useState(0);
  const customerIdRef = useRef(null);

  useEffect(() => {
    customerIdRef.current = values.customerId;
  }, [values.customerId]);
  const inputChange = async (
    val,
    index,
    status,
    setStatus,
    invoiceType,
    setShowAddItemButton,
    salesOrderId,
    checkDirectInvoice,
    contactId
  ) => {
    var item = getFilteredItem(val, status.itemsList);
    if (item && item.length === 1) {
      handleSelectedItems(
        item[0],
        index,
        status,
        setStatus,
        invoiceType,
        setShowAddItemButton,
        salesOrderId,
        checkDirectInvoice,
        contactId
      );
    }
  };
  const handleSelectedItems = async (
    option,
    index,
    status,
    setStatus,
    invoiceType,
    setShowAddItemButton,
    salesOrderId,
    checkDirectInvoice,
    contactId
  ) => {
    if (option.value === 'createNew') {
      setStatus({ ...status, showItemModal: true });
    } else {
      const prepareoption = await prepareItemsList(
        [option],
        values?.items[index]?.warehouseId
      );
      const response = await getPreviousSellingPrice(
        contactId,
        [option.id],
        status,
        setStatus
      );
      let previousRate = response.find((o) => o.item_id === option.id);
      setLoadingItem(true);

      // Item's sales_unit_price is always in base currency
      const itemBasePriceFromDB = option?.sales_unit_price || option?.unitPrice;
      // Get current selected currency
      const selectedCurrency = baseCurrencylist.find(
        (item) => item.id === values.globalCurrency
      );

      // The base currency value is the item's original price
      let baseCurrencyValue = itemBasePriceFromDB;

      // Calculate unitPrice based on current currency
      let unitPrice;
      if (selectedCurrency && selectedCurrency.is_base_currency) {
        // If in base currency, use the base price directly
        unitPrice = itemBasePriceFromDB;
      } else {
        // If in foreign currency, convert base price to foreign currency
        unitPrice =
          values.exchangeRate > 0
            ? itemBasePriceFromDB * values.exchangeRate
            : itemBasePriceFromDB;
      }
      const newItem = {
        ...option,
        accountId: option?.sales_account_id,
        dragDropID: GetDateString(),
        quantity: values.items[index].quantity,
        warehouseId: primaryWarehouse,
        unitPrice: unitPrice,
        baseCurrencyValue: baseCurrencyValue,
        discount: 0,
        discountType: 'percent',
        previousSellingBasePrice: previousRate?.rate || 0,
        previousSellingPrice: previousRate?.exchanged_rate || 0,
        previousSellingPriceCurrencyId: previousRate?.currency_id || null,
        previous_exchange_rate: previousRate?.exchange_rate || 1,
      };

      // Calculate total with the newItem data
      newItem.total = parseFloat(getItemTotalAmount(newItem));
      setShowAddItemButton(true);
      //below code run for so invoice and direct edit invoice, adds selected item to dropdown list and removes duplicated,
      if (inModal || (type === 'edit' && invoice.soId)) {
        direcInvItems = direcInvItems.filter(
          (item) =>
            item.salesOrderItemDetailId !== option.salesOrderItemDetailId
        );
        setStatus({
          ...status,
          itemsList: Array.from(
            new Set(direcInvItems.map((a) => a.salesOrderItemDetailId))
          ).map((salesOrderItemDetailId) => {
            return direcInvItems.find(
              (a) => a.salesOrderItemDetailId === salesOrderItemDetailId
            );
          }),
        });
        setLoadingItem(false);
      }
      setFieldValue(`items[${index}]`, { ...newItem });
      if (invoiceType === 'edit' && checkDirectInvoice !== false) {
        return;
      }
      if (option.inventoryType === 'noninventory' || salesOrderId) {
        /*setStatus({
          ...status,
          itemsList: status.itemsList.filter(item =>  item.id !== option.id )
        })*/
      }
      setLoadingItem(false);
    }
  };

  const getTaxAmount = (quantity, unitPrice, taxRate, taxType, tax_per_measurement, volume_per_piece, pack_quantity) => {
    // console.log('Calculating tax amount individual with:', { quantity, unitPrice, taxRate, taxType, tax_per_measurement }); // Debug log
    if (taxType === "fixed" && tax_per_measurement) {
      return taxRate * volume_per_piece * (pack_quantity * quantity);
    } else if (taxType === "percentage" && tax_per_measurement) {
      return taxRate * volume_per_piece * (pack_quantity * quantity) / 100;
    }
    return taxType === "fixed" ? taxRate * quantity : parseFloat((quantity * unitPrice * taxRate) / 100);
  };

  const handleItemQuantityChange = (quantityValue, index) => {
    let quantity = quantityValue.floatValue;
    if (quantity > 0) {
      let quantString = quantity.toString();

      // Price_Quantity_Limit

      // price and quantity limit from 5 digits to 10 digits
      if (quantString.length > 10) {
        quantString = quantString.slice(0, 10);
      }
      quantity = parseFloat(quantString);
    }
    let itemsList = [...values.items];
    let currentItem = itemsList[index];
    itemsList[index] = {
      ...currentItem,
      quantity: quantity ? quantity : null,
      taxAmount: !!currentItem?.tax?.id
        ? getTaxAmount(quantity, currentItem.unitPrice, currentItem.tax.rate, currentItem.tax.type, currentItem.tax_per_measurement, currentItem.volume_per_piece, currentItem.pack_quantity)
        : 0,
      total: parseFloat(
        getItemTotalAmount({ ...currentItem, quantity })
      )?.toFixed(2),
    };
    setFieldValue('items', itemsList);
  };

  const handleTaxChange = (option, index) => {
    let itemsList = [...values.items];
    let currentItem = itemsList[index];
    if (option === null) {
      itemsList[index] = {
        ...currentItem,
        tax: {
          id: null,
          name: '',
          rate: 0,
        },
        taxAmount: 0,
      };
    } else {
      itemsList[index] = {
        ...currentItem,
        tax: {
          id: option.id,
          name: option.name,
          rate: option.rate,
          type: option.type,
        },
        taxAmount: getTaxAmount(
          currentItem.quantity,
          currentItem.unitPrice,
          option.rate,
          option.type,
          currentItem.tax_per_measurement,
          currentItem.volume_per_piece,
          currentItem.pack_quantity
        ),
      };
    }
    setFieldValue('items', itemsList);
  };

  const handleChangeprevPrice = (prevPrice, index) => {
    isManualChange.current = true; // Mark as manual update

    let itemList = [...values.items];
    let currentItem = itemList[index];

    // Calculate baseCurrencyValue based on current currency
    const selectedCurrency = baseCurrencylist.find(
      (item) => item.id === values.globalCurrency
    );

    let baseCurrencyValue;
    if (selectedCurrency && selectedCurrency.is_base_currency) {
      // If in base currency, the unitPrice IS the base value
      baseCurrencyValue = prevPrice;
    } else {
      // If in foreign currency, calculate base value
      baseCurrencyValue =
        values.exchangeRate > 0 ? prevPrice / values.exchangeRate : prevPrice;
    }

    itemList[index] = {
      ...currentItem,
      unitPrice: prevPrice,
      baseCurrencyValue,
    };
    setFieldValue('items', itemList);
  };
  const handleItemPriceChange = (unitPriceValue, index) => {
    isManualChange.current = true; // 👈 mark manual update

    let unitPrice = unitPriceValue.floatValue;

    if (unitPrice > 0) {
      let unitPriceString = unitPrice.toString();
      if (unitPriceString.length > 10) {
        unitPriceString = unitPriceString.slice(0, 10);
      }
      unitPrice = parseFloat(unitPriceString);
    }

    let itemsList = [...values.items];
    let currentItem = itemsList[index];

    // Calculate baseCurrencyValue based on current currency
    const selectedCurrency = baseCurrencylist.find(
      (item) => item.id === values.globalCurrency
    );

    let baseCurrencyValue;
    if (selectedCurrency && selectedCurrency.is_base_currency) {
      // If in base currency, the unitPrice IS the base value
      baseCurrencyValue = unitPrice;
    } else {
      // If in foreign currency, calculate base value
      baseCurrencyValue =
        values.exchangeRate > 0 ? unitPrice / values.exchangeRate : unitPrice;
    }

    itemsList[index] = {
      ...currentItem,
      unitPrice,
      baseCurrencyValue,
      taxAmount: !!currentItem?.tax?.id
        ? getTaxAmount(currentItem.quantity, unitPrice, currentItem.tax.rate, currentItem.tax.type, currentItem.tax_per_measurement, currentItem.volume_per_piece, currentItem.pack_quantity)
        : 0,
      total: parseFloat(getItemTotalAmount({ ...currentItem, unitPrice })),
    };

    setFieldValue('items', itemsList);
  };

  const handleAdjustmentChange = (adjustmentValue) => {
    isManualChange.current = true; // Mark as manual change

    let adjustment = adjustmentValue.floatValue;
    if (adjustment > 0) {
      let adjustmentString = adjustment.toString();

      // Price_Quantity_Limit

      // price and quantity limit from 5 digits to 10 digits
      if (adjustmentString.length > 10) {
        adjustmentString = adjustmentString.slice(0, 10);
      }
      adjustment = parseFloat(adjustmentString);
    }

    // Calculate baseAdjustment based on current currency
    const selectedCurrency = baseCurrencylist.find(
      (item) => item.id === values.globalCurrency
    );

    let baseAdjustment;
    if (selectedCurrency && selectedCurrency.is_base_currency) {
      // If in base currency, the adjustment IS the base value
      baseAdjustment = adjustment;
    } else {
      // If in foreign currency, calculate base value
      baseAdjustment =
        values.exchangeRate > 0 ? adjustment / values.exchangeRate : adjustment;
    }

    setFieldValue('adjustment', adjustment);
    setFieldValue('baseAdjustment', baseAdjustment);
  };

  const handleShipChargeChange = (shippingValue) => {
    isManualChange.current = true; // Mark as manual change

    let shipping = shippingValue.floatValue;
    if (shipping > 0) {
      let shippingString = shipping.toString();

      // Price_Quantity_Limit

      // price and quantity limit from 5 digits to 10 digits
      if (shippingString.length > 10) {
        shippingString = shippingString.slice(0, 10);
      }
      shipping = parseFloat(shippingString);
    }

    // Calculate baseShippingCharge based on current currency
    const selectedCurrency = baseCurrencylist.find(
      (item) => item.id === values.globalCurrency
    );

    let baseShippingCharge;
    if (selectedCurrency && selectedCurrency.is_base_currency) {
      // If in base currency, the shipping charge IS the base value
      baseShippingCharge = shipping;
    } else {
      // If in foreign currency, calculate base value
      baseShippingCharge =
        values.exchangeRate > 0 ? shipping / values.exchangeRate : shipping;
    }

    setFieldValue('shippingCharge', shipping);
    setFieldValue('baseShippingCharge', baseShippingCharge);
  };

  const handleDiscountTypeChange = (option, index) => {
    let discountType = option.value;
    let itemsList = [...values.items];
    itemsList[index] = {
      ...itemsList[index],
      discountType,
      total: parseFloat(
        getItemTotalAmount({ ...itemsList[index], discountType })
      ),
    };
    setFieldValue('items', itemsList);
  };

  const handleItemDiscountChangeT = (value, discountType) => {
    let discount = value.floatValue;
    if (discount > 0) {
      let discountString = discount.toString();
      if (discountType === 'percent') {
        let sliceStrLen = discountString.includes('.') ? 5 : 3;
        if (discountString.length > sliceStrLen) {
          discountString = discountString.slice(0, sliceStrLen);
        }
        discount = parseFloat(discountString);
      } else {
        if (discountString.length > 10) {
          discountString = discountString.slice(0, 10);
        }
        discount = parseFloat(discountString);
      }
    }

    // For percentage discount, we don't need to update baseTransactionDiscount
    if (discountType === 'percent') {
      setFieldValue('transactionDiscount', discount);
      setFieldValue('baseTransactionDiscount', discount);
      return;
    }

    // For amount discount, check if we're in the base currency or have an exchange rate
    const isBaseCurrency = baseCurrencylist.some(
      (currency) =>
        currency.id === values.globalCurrency && currency.is_base_currency
    );

    if (isBaseCurrency || !values.exchangeRate) {
      // If in base currency or no exchange rate, set both values to the entered amount
      setFieldValue('transactionDiscount', discount);
      setFieldValue('baseTransactionDiscount', discount);
    } else {
      // For foreign currency with exchange rate, calculate the base value
      const baseValue = discount / values.exchangeRate;
      setFieldValue('transactionDiscount', discount);
      setFieldValue('baseTransactionDiscount', baseValue);
    }
  };

  const handleItemDiscountChange = (value, index, discountType) => {
    let discount = value.floatValue;
    if (discount > 0) {
      let discountString = discount.toString();
      if (discountType === 'percent') {
        let sliceStrLen = discountString.includes('.') ? 5 : 3;
        if (discountString.length > sliceStrLen) {
          discountString = discountString.slice(0, sliceStrLen);
        }
        discount = parseFloat(discountString);
      } else {
        if (discountString.length > 10) {
          discountString = discountString.slice(0, 10);
        }
        discount = parseFloat(discountString);
      }
    }

    // Get the current item
    const itemsList = [...values.items];
    const currentItem = { ...itemsList[index] };

    // For percentage discount, we don't need to update baseDiscountValue
    if (discountType === 'percent') {
      itemsList[index] = {
        ...currentItem,
        discount,
        total: parseFloat(getItemTotalAmount({ ...currentItem, discount })),
      };
      setFieldValue('items', itemsList);
      return;
    }

    // For amount discount, handle currency conversion
    const selectedCurrency = baseCurrencylist.find(
      (item) => item.id === values.globalCurrency
    );

    let baseDiscountValue;
    if (selectedCurrency && selectedCurrency.is_base_currency) {
      // If in base currency, the discount IS the base value
      baseDiscountValue = discount;
    } else {
      // If in foreign currency, calculate base value
      baseDiscountValue =
        values.exchangeRate > 0 ? discount / values.exchangeRate : discount;
    }

    // Update the item with both the current discount and base discount value
    itemsList[index] = {
      ...currentItem,
      discount,
      baseDiscountValue,
      total: parseFloat(getItemTotalAmount({ ...currentItem, discount })),
    };

    setFieldValue('items', itemsList);
  };

  const deleteSalesOrderFromList = (option = {}) => {
    let { currentSalesOrderId = null, id = '' } = option;
    if (currentSalesOrderId) {
      let modifiledSalesOrderList = status.confirmedSalesOrdersList;
      modifiledSalesOrderList = modifiledSalesOrderList.map(
        (singleSalesOrder) => {
          if (singleSalesOrder.id === currentSalesOrderId) {
            let itemsListModified =
              singleSalesOrder.sales_order_item_details.map((singleItem) => {
                if (id === singleItem.item_id) {
                  return {
                    ...singleItem,
                    hasItemAdded: false,
                  };
                } else {
                  return singleItem;
                }
              });
            return {
              ...singleSalesOrder,
              selectedByItem: false,
              sales_order_item_details: itemsListModified,
            };
          } else {
            return singleSalesOrder;
          }
        }
      );

      setStatus({
        ...status,
        confirmedSalesOrdersList: modifiledSalesOrderList,
        selectedConfirmedSalesOrderIds: [],
        selectedConfirmedSalesOrderIds:
          status.selectedConfirmedSalesOrderIds.filter(
            (id) => id !== currentSalesOrderId
          ),
      });
    }
  };

  const handleRemoveItem = (
    removeIndex,
    status,
    setStatus,
    option,
    invoiceType,
    salesOrderId
  ) => {
    deleteSalesOrderFromList(option);
    !inModal && values.items.length === 1 && values.items.push(emptyItem);
    const updatedItems = values.items.filter(
      (_, index) => index !== removeIndex
    );

    const showButton = updatedItems.some((item) => item.id === null);
    setShowAddItemButton(!showButton);
    setFieldValue('items', updatedItems);
    //below code run for so invoice and direct edit invoice, removing duplicates and adding removed item into dropdown list,
    if (inModal || (type === 'edit' && invoice.soId)) {
      option.id !== null && direcInvItems.push(option);
      setStatus({
        ...status,
        itemsList: [
          ...Array.from(
            new Set(direcInvItems.map((a) => a.salesOrderItemDetailId))
          ).map((salesOrderItemDetailId) => {
            return direcInvItems.find(
              (a) => a.salesOrderItemDetailId === salesOrderItemDetailId
            );
          }),
        ],
      });
    }
    if (invoiceType === 'edit') {
      if (status.itemsList.find((item) => item.sku === option.sku)) {
        return;
      } else {
        /*setStatus({
          ...status,
          itemsList: [...status.itemsList, option]
        });*/
        return;
      }
    }
    if (
      (option.id != null && option.inventoryType === 'noninventory') ||
      (option.id !== null && salesOrderId)
    ) {
      if (status.itemsList.find((item) => item.sku === option.sku)) {
        return;
      } else {
        /*setStatus({
          ...status,
          itemsList: [...status.itemsList, option]
        });*/
        return;
      }
    }
  };
  // let location = useLocation();
  // const [myWareId, setMyWareId] = useState({});
  const [flag, setflag] = useState(false);
  const [, setWarehouseList] = useState({});
  const [, setShowMergeModal] = useState(false);
  const [, setWarehouseNames] = useState([]);
  const [showAddItemButton, setShowAddItemButton] = useState(
    type === 'edit' && checkDirectInvoice === false ? true : false
  );

  const [sales_invoice_loading, setSales_invoice_loading] = useState(false);

  React.useEffect(() => {
    contactIdTransaction &&
      setFieldValue('customerId', parseInt(contactIdTransaction));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setWarehouseList(warehousesList);
    setflag(true);
    let tempArray = [];
    values.items.forEach((item) => {
      tempArray.push(item.name);
    });
    setWarehouseNames(tempArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.items]);
  useEffect(() => {
    setFieldValue('overAllTotalTaxInValues', overAllTotalTax);
    return () => {
      setShowMergeModal(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (salesOrderId && !values.items.length) {
      setShowAddItemButton(false);
    } else if (invoiceItemsLength === values?.items?.length) {
      setShowAddItemButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.items]);

  useEffect(() => {
    if (values.items.length === 0) {
      setShowAddItemButton(false);
    }
  }, [values.items]);

  // useEffect(() => {
  //   let editableItems = [...values.items];
  //   editableItems.forEach((item, index) => {
  //     editableItems[index] = {
  //       ...item,
  //       previousSellingPrice: previousPurchasePrices[index]
  //         ? previousPurchasePrices[index]
  //         : 0,
  //     };
  //   });
  //   setFieldValue('items', editableItems);
  //   setItemsList(editableItems);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [previousPurchasePrices]);

  const renderSelectedItemsTable = (invoiceType) => {
    if (values.items.length > 0) {
      values.items.forEach(function (value) {
        if (value.warehouseId === null) {
          value.warehouseId = primaryWarehouse;
        }
      });
    }

    const handleOnDragEnd = (result) => {
      if (!result.destination) return;
      const items = Array.from(values.items);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      setFieldValue('items', items);
    };

    const handleArrowsKey = (e, index, fieldname) => {
      if (e.key === 'ArrowDown' && index + 1 < values?.items?.length) {
        const element = document.getElementById(
          `items[${index + 1}].${fieldname}`
        );
        setTimeout(() => {
          element.select();
          element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, 100);
      }
    };

    const handleArrowUpKey = (e, index, fieldname) => {
      if (e.key === 'ArrowUp' && index - 1 >= 0) {
        const element = document.getElementById(
          `items[${index - 1}].${fieldname}`
        );
        element.select();
        element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    };

    const { items, discountLevel } = values;
    //console.log(temporary_edit, "temporary_edit")
    return (
      <div className="so-tbletabs">
        <table
          className={`list-table form-focus form-table border ${!inModal
            ? 'create_invoice w-100 uiux_invoice_add'
            : 'create_invoice'
            } uiux_invoice_edit_form
      ${discountLevel === 'transaction' || discountLevel === 'no_discount'
              ? 'horizontal-items-table no-discount-table'
              : 'discount-added'
            }
       ${type === 'edit' && itemLevelIndvidual ? 'discount-added' : ''}`}
        >
          <thead>
            <tr className="table--row">
              <th>{t('Invoice.invoice_form.items')}</th>
              <th>{t('Invoice.invoice_form.warehouse')}</th>
              <th className="">{t('Invoice.invoice_form.qty')}</th>
              <th className="">{t('Invoice.invoice_form.price')}</th>
              {(discountLevel === 'item' ||
                discountPreference.at_individual_item_level) &&
                discountLevel !== 'transaction' && (
                  <th className="uiux_so_discount">
                    {t('Invoice.invoice_form.discount')}
                  </th>
                )}
              <th>{t('Invoice.invoice_form.tax')}</th>

              <th className="">{t('Invoice.invoice_form.amount')}</th>
            </tr>
          </thead>
          {flag ? (
            <DragDropItems handleOnDragEnd={handleOnDragEnd}>
              {items.map((item, index) => {
                let quan;
                return (
                  <Draggable
                    key={item.dragDropID}
                    draggableId={item.dragDropID}
                    index={index}
                  >
                    {(provided) => (
                      <tr
                        key={index}
                        className="table--row"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                      >
                        <td>
                          <div className="__dragDrop">
                            <div
                              {...provided.dragHandleProps}
                              className={
                                values.items.length >= 2
                                  ? '__dragDrop_iconParent'
                                  : '__dragDrop_iconParent notDisplay'
                              }
                              tabIndex="-1"
                            >
                              <MdDragIndicator />
                            </div>
                            <div className="__drag-righ">
                              {item.id || item.value ? (
                                <div className="invoice-form">
                                  <ListTableImageColumn
                                    name={
                                      item.name ||
                                      item.label.props.children[1].props
                                        .children[0]
                                    }
                                    images={item.images}
                                    sku={item.sku}
                                    id={item.id}
                                    showModalUponClick={inModal ? false : true}
                                    value={item.extra_description}
                                    index={index}
                                    showExtraDescription={true}
                                    onChangeValue={onChangeValueHandler}
                                  />
                                </div>
                              ) : (
                                <>
                                  {' '}
                                  {!inModal && !checkDirectInvoice ? (
                                    <Field
                                      id="itemId"
                                      autoFocus={true}
                                      addButton={!checkDirectInvoice}
                                      type="DynamicPaginationDropdown"
                                      value={item.id}
                                      disabled={!values.customerId}
                                      withImage={true}
                                      api="invoices/items"
                                      placeholder={
                                        values.customerId
                                          ? t('Invoice.invoice_form.label')
                                          : t(
                                            'Invoice.invoice_form.pleaseSelectCustomer'
                                          )
                                      }
                                      alphabetSort
                                      searchKeys={[
                                        'name',
                                        'sku',
                                        'upc',
                                        'mpn',
                                        'ean',
                                        'isbn',
                                      ]}
                                      clearable={false}
                                      itemsDropDown={true}
                                      handleChange={(option) => {
                                        handleSelectedItems(
                                          option,
                                          index,
                                          status,
                                          setStatus,
                                          invoiceType,
                                          setShowAddItemButton,
                                          salesOrderId,
                                          checkDirectInvoice,
                                          customerIdRef.current
                                        );
                                      }}
                                      error={getError(
                                        errors,
                                        touched,
                                        `items[${index}].name`
                                      )}
                                      onBlur={() =>
                                        setFieldTouched(
                                          `items[${index}].name`,
                                          true
                                        )
                                      }
                                    />
                                  ) : (
                                    <Field
                                      id="itemId"
                                      autoFocus={true}
                                      addButton={!checkDirectInvoice}
                                      type="PaginationDropdown"
                                      value={item.id}
                                      options={status.itemsList}
                                      dropdownValue="id"
                                      dropdownLabel="name"
                                      disabled={!values.customerId}
                                      withImage={true}
                                      placeholder={
                                        values.customerId
                                          ? t('Invoice.invoice_form.label')
                                          : t(
                                            'Invoice.invoice_form.pleaseSelectCustomer'
                                          )
                                      }
                                      alphabetSort
                                      searchKeys={[
                                        'name',
                                        'sku',
                                        'upc',
                                        'mpn',
                                        'ean',
                                        'isbn',
                                      ]}
                                      clearable={false}
                                      itemsDropDown={true}
                                      onInputChange={(option) => {
                                        inputChange(
                                          option,
                                          index,
                                          status,
                                          setStatus,
                                          invoiceType,
                                          setShowAddItemButton,
                                          salesOrderId,
                                          checkDirectInvoice,
                                          values.customerId
                                        );
                                      }}
                                      handleChange={(option) => {
                                        return handleSelectedItems(
                                          option,
                                          index,
                                          status,
                                          setStatus,
                                          invoiceType,
                                          setShowAddItemButton,
                                          salesOrderId,
                                          checkDirectInvoice,
                                          values.customerId
                                        );
                                      }
                                      }
                                      error={getError(
                                        errors,
                                        touched,
                                        `items[${index}].name`
                                      )}
                                      onBlur={() =>
                                        setFieldTouched(
                                          `items[${index}].name`,
                                          true
                                        )
                                      }
                                    />
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="no-padding">
                          <Field
                            id="warehouseId"
                            type="dropdown"
                            disabled={
                              owner_can_edit_in_lock_status ||
                              item.salesOrderItemDetailId ||
                              item.inventoryType === 'noninventory' ||
                              !values.customerId
                            }
                            placeholder={t('Invoice.invoice_form.select')}
                            value={
                              item.warehouseId
                                ? item.warehouseId
                                : primaryWarehouse
                            }
                            options={warehousesList}
                            dropdownValue="id"
                            dropdownLabel="name"
                            clearable={false}
                            required
                            handleChange={(option) =>
                              setFieldValue(
                                `items[${index}].warehouseId`,
                                option ? option.value : null
                              )
                            }
                          />
                        </td>

                        <td className="right-align no-padding">
                          <Field
                            size="small"
                            type="number"
                            value={item.quantity}
                            decimalScale={0}
                            id={`items[${index}].quantity`}
                            allowNegative={false}
                            thousandSeparator=","
                            onValueChange={(value) =>
                              handleItemQuantityChange(value, index)
                            }
                            error={getError(
                              errors,
                              touched,
                              `items[${index}].quantity`
                            )}
                            onBlur={handleBlur}
                            onKeyDown={(e) =>
                              handleArrowsKey(e, index, 'quantity')
                            }
                            onKeyUp={(e) =>
                              handleArrowUpKey(e, index, 'quantity')
                            }
                          // disabled={owner_can_edit_in_lock_status}
                          />
                          <div className="table-extra-data right-align order-invoice">
                            <div style={{ marginTop: '1.3rem' }}>
                              {item.ordered ? (
                                <>
                                  <p className="mb-0">
                                    {' '}
                                    {t('Invoice.invoice_form.ordered')}:{' '}
                                    {item.ordered} {item.unit}
                                  </p>
                                  <p className="mb-0">
                                    {' '}
                                    {t('Invoice.invoice_form.invoiced')}:{' '}
                                    {item.invoiced} {item.unit}
                                  </p>
                                </>
                              ) : (
                                ''
                              )}
                            </div>
                            {type === 'add' && !inModal && (
                              <Fragment>
                                {item?.item_stocks &&
                                  item?.item_stocks.forEach((stock) => {
                                    // console.log('stock', stock);
                                    if (
                                      stock.warehouse_id === item.warehouseId
                                    ) {
                                      quan = stock.physical_quantity;
                                    }
                                  })}
                                {item.inventoryType === 'noninventory' || item.inventory_type === 'noninventory'
                                  ? 'Untracked'
                                  : item.inventoryType === 'inventory' || item.inventory_type === 'inventory' && (
                                    <>
                                      {quan ? quan : '0'} {item.unit}
                                    </>
                                  )}
                              </Fragment>
                            )}
                          </div>
                        </td>
                        <td className="right-align no-padding previous_sold">
                          <Field
                            size="small"
                            type="number"
                            disabled={false}
                            value={item.unitPrice}
                            decimalScale={4}
                            id={`items[${index}].unitPrice`}
                            prefix={getcurrencysymble()}
                            placeholder="$0"
                            allowNegative={false}
                            thousandSeparator=","
                            onValueChange={(values) =>
                              handleItemPriceChange(values, index)
                            }
                            error={getError(
                              errors,
                              touched,
                              `items[${index}].unitPrice`
                            )}
                            onBlur={handleBlur}
                            onKeyDown={(e) =>
                              handleArrowsKey(e, index, 'unitPrice')
                            }
                            onKeyUp={(e) =>
                              handleArrowUpKey(e, index, 'unitPrice')
                            }
                          />
                          {!!item.previousSellingPrice && (
                            <>
                              <span className="icon_div invoice-tooltip-main">
                                <div
                                  style={{ cursor: 'pointer' }}
                                  onClick={() =>
                                    handleChangeprevPrice(
                                      item?.previousSellingBasePrice *
                                      values?.exchangeRate,
                                      index
                                    )
                                  }
                                >
                                  {`${t(
                                    'Invoice.invoice_form.prev_sold'
                                  )}: ${getcurrencysymble()}${parseFloat(
                                    (item.previousSellingPrice /
                                      item.previous_exchange_rate) *
                                    (values?.exchangeRate || 1)
                                  )?.toFixed(2)}`}
                                </div>
                                <div className="table-extra-data right-align">
                                  <div className="tooltip_tooltip invoice-tooltip">
                                    <p>{t('Invoice.invoice_form.set_price')}</p>
                                    {/* {`Prev Sold: ${currency.symbol}${item.previousSellingPrice}`} */}
                                  </div>
                                </div>
                              </span>
                              {/* <ToolTip content="Click to set this price">
                                <div className="table-extra-data right-align">
                                  <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                      handleChangeprevPrice(
                                        item?.previousSellingPrice,
                                        index
                                      )
                                    }
                                  >
                                    {`Prev Sold: ${currency.symbol}${item.previousSellingPrice}`}
                                  </div>
                                </div>
                              </ToolTip> */}
                            </>
                          )}
                        </td>
                        {(discountLevel === 'item' ||
                          discountPreference.at_individual_item_level) &&
                          discountLevel !== 'transaction' && (
                            <td className="right-align item-level-discount no-padding discount_switch">
                              <Field
                                size="xs"
                                type="number"
                                //value={item.discount}
                                value={parseFloat(item.discount)?.toFixed(2)}
                                decimalScale={2}
                                id={`items[${index}].discount`}
                                rightData={
                                  <Switch
                                    options={getDiscountOptions(
                                      currency,
                                      getcurrencysymble
                                    )}
                                    value={item.discountType}
                                    handleChange={(option) =>
                                      handleDiscountTypeChange(option, index)
                                    }
                                  />
                                }
                                allowNegative={false}
                                thousandSeparator=","
                                onValueChange={(values) =>
                                  handleItemDiscountChange(
                                    values,
                                    index,
                                    item.discountType
                                  )
                                }
                                error={getError(
                                  errors,
                                  touched,
                                  `items[${index}].discount`
                                )}
                                onBlur={handleBlur}
                                onKeyDown={(e) =>
                                  handleArrowsKey(e, index, 'discount')
                                }
                                onKeyUp={(e) =>
                                  handleArrowUpKey(e, index, 'discount')
                                }
                                removeValueOnClick
                              />
                            </td>
                          )}
                        <td className="no-padding">
                          <Field
                            size="small"
                            type="dropdown"
                            placeholder={t('Invoice.invoice_form.selectTax')}
                            value={item?.tax?.id}
                            options={taxList}
                            dropdownValue="id"
                            dropdownLabel="name"
                            handleChange={(option) =>
                              handleTaxChange(option, index)
                            }
                          />
                        </td>
                        <td className="list-table--amount right-align">
                          <span>
                            {getcurrencysymble()}
                            {parseFloat(item.total).toFixed(2)}
                          </span>
                          <button
                            disabled={
                              inModal
                                ? items.length === 1
                                : (values.items.length === 1 &&
                                  values.items[0].id === null) ||
                                owner_can_edit_in_lock_status
                            }
                            type="button"
                            className="close-btn button"
                            onClick={() =>
                              handleRemoveItem(
                                index,
                                status,
                                setStatus,
                                item,
                                invoiceType,
                                salesOrderId
                              )
                            }
                          >
                            <DeleteIcon className="bin" />
                          </button>
                        </td>
                      </tr>
                    )}
                  </Draggable>
                );
              })}
            </DragDropItems>
          ) : (
            <tbody>
              <tr>
                <td>{t('Invoice.invoice_form.loading')}</td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    );
  };

  let getSubtotal = (itemsList) => {
    return itemsList
      .reduce((total, item) => parseFloat(total) + parseFloat(item.total), 0.0)
      .toFixed(2);
  };

  const renderTotalTax = () => {
    let overallTax = getOverallTaxDetails(values.items);
    return overallTax.map((tax) => {
      // console.log('Rendering tax:', { tax });
      return (
        <div className="float-left w-100" key={tax.id}>
          <span className="semi-bold float-left">
            {tax.name} ({tax.type == "fixed" && currency?.symbol}{tax.rate}{tax.type !== "fixed" && "%"})
          </span>          <span className="float-right">{`${getcurrencysymble()}${parseFloat(
            tax.total
          ).toFixed(2)}`}</span>
        </div>
      );
    });
  };
  const onChangeValueHandler = (val, index) => {
    let newVal = handleExtraDescription(val, 254);
    values.items[index].extra_description = newVal;
    setFieldValue(`values.items[${index}].extra_description`, newVal);
  };
  const overAllTotalTax = () => {
    let overallTax = getOverallTaxDetails(values.items);
    let TotalTax = 0;
    overallTax.forEach((tax) => {
      TotalTax = TotalTax + tax.total;
    });
    return TotalTax;
  };

  const renderOrderSummary = () => {
    return (
      <div className="float-left w-100 mt_3 summary_table">
        <hr className="margin float-left w-100" />
        <div className="float-left w-60 p_10"></div>
        <div className="float-left w-40 p_10 pr_2">
          <div className="float-left w-100">
            <span className="float-left">
              {t('Invoice.invoice_form.subTotal')}
            </span>
            <span className="float-right bold">{`${getcurrencysymble()}${getSubtotal(
              values.items
            )}`}</span>
          </div>

          {renderTotalTax()}

          {(values.discountLevel === 'transaction' ||
            discountPreference.at_transaction_level) &&
            values.discountLevel !== 'item' && (
              <div className="float-left w-100">
                <span className="float-left pr">
                  {t('Invoice.invoice_form.discount')}
                </span>
                <Field
                  className="float-right bold discount_switch_summary_table"
                  // size='medium'
                  type="number"
                  // value={values.transactionDiscount}
                  value={parseFloat(values.transactionDiscount).toFixed(2)}
                  decimalScale={2}
                  size="xs"
                  id="transactionDiscount"
                  rightData={
                    <Switch
                      options={getDiscountOptions(currency, getcurrencysymble)}
                      value={values.transactionDiscountType}
                      handleChange={(value) => {
                        setFieldValue('transactionDiscountType', value.value);
                      }}
                    />
                  }
                  allowNegative={false}
                  thousandSeparator=","
                  onValueChange={
                    (value) =>
                      handleItemDiscountChangeT(
                        value,
                        values.transactionDiscountType
                      )
                    // setFieldValue('transactionDiscount', value.floatValue)
                  }
                  onBlur={handleBlur}
                  error={
                    touched.transactionDiscount && errors.transactionDiscount
                  }
                  removeValueOnClick
                />
              </div>
            )}

          <div className="float-left w-100">
            <span className="float-left pr">
              {t('Invoice.invoice_form.adjustment')}
            </span>
            <Field
              className="float-right adj-shipping-invoice-field bold"
              type="number"
              value={parseFloat(values.adjustment).toFixed(2)}
              decimalScale={2}
              allowNegative
              id="adjustment"
              placeholder={`${getcurrencysymble()}0.00`}
              prefix={getcurrencysymble()}
              thousandSeparator=","
              //onValueChange={value => setFieldValue('adjustment', value.floatValue)}
              onValueChange={(value) => handleAdjustmentChange(value)}
              onBlur={handleBlur}
              error={touched.adjustment && errors.adjustment}
              removeValueOnClick
            />
          </div>

          <div className="float-left w-100">
            <span className="float-left pr">
              {t('Invoice.invoice_form.shipping')}
            </span>
            <Field
              className="float-right adj-shipping-invoice-field bold"
              type="number"
              value={parseFloat(values.shippingCharge).toFixed(2)}
              decimalScale={2}
              id="shippingCharge"
              placeholder={`${getcurrencysymble()}0.00`}
              prefix={getcurrencysymble()}
              thousandSeparator=","
              //onValueChange={value => setFieldValue('shippingCharge', value.floatValue)}
              onValueChange={(value) => handleShipChargeChange(value)}
              onBlur={handleBlur}
              error={touched.shippingCharge && errors.shippingCharge}
              removeValueOnClick
            />
          </div>
        </div>

        <hr className="margin float-left w-100" />
        <div className="float-left w-100">
          <div className="float-left w-60 p_10"></div>
          <div className="baseline float-left w-40 px_10">
            <span className="semi-bold float-left pr_total">
              {t('Invoice.invoice_form.total')}
            </span>
            <span className="total-price--value float-right mr-1">{`${getcurrencysymble()}${!isNaN(getOrderTotal(values, overAllTotalTax))
              ? getOrderTotal(values, overAllTotalTax)?.toFixed(2)
              : 0.0
              }`}</span>
          </div>
        </div>
        <hr className="margin float-left w-100" />
        <hr className="margin float-left w-100" />
      </div>
    );
  };

  const renderActionButtons = () => {
    return (
      <FormAction
        disabled={isSubmitting}
        type="button"
        className="UIUX_invoice_actions"
        onSubmit={handleSubmit}
        marginFromRight={0}
        showSaveAndSendButton={true}
        hideSaveButtons={temporary_edit}
        customActionButton={
          temporary_edit
            ? {
                label: t('Invoice.invoice_form.showPdf'),
                onClick: () => openInvoicePdf(),
              }
            : null
        }
        saveAndSendField={{
          label: t('Invoice.invoice_form.saveAndSend'),
          onClick: (event) => {
            props.setPrompt(false);
            handleSaveAndSend(event);
            handleSubmit();
          },
        }}
        onCancel={() => {
          let dataFromLS = getObjFromLS('module');
          let redirectUrl = '';
          if (dataFromLS && dataFromLS.moduleName === 'invoices') {
            redirectUrl = dataFromLS.queryParam;
          }
          if (dataFromLS.moduleName === 'contacts') {
            history.push('/contacts');
            return;
          }
          if (inModal) {
            let response;
            let value = { ...values };
            delete value.overAllTotalTaxInValues;
            let { checkout } = validateInvoiceForm(value, {
              ...staticVal,
              items: itemsList,
            });
            if (!checkout) {
              response = confirmationAlert();
            }
            if (response || checkout) {
              close();
            }
          } else if (
            window.location.pathname.includes('add') ||
            window.location.pathname.includes('edit')
          ) {
            history.push('/invoices' + redirectUrl);
          } else {
            setObjInLS('module', { ...dataFromLS, action: null });
            history.push('/r');
          }
        }}
      />
    );
  };
  const handleSaveAndSend = (event) => {
    setFieldValue('saveAndSend', true);
    mergeItems(event);
    // formSubmit(event, values.items, setFieldValue, handleSubmit)
  };
  const invoiceTermModal = () => {
    return (
      <CustomModal
        showModal={status.showTermsModal}
        title={t('Invoice.invoice_form.invoiceTerms')}
        renderActions={false}
        onClose={() => setStatus({ ...status, showTermsModal: false })}
        showPrompt={showPrompt}
      >
        <InvoiceTermUpdate
          type="modal"
          close={() => {
            setStatus({ ...status, showTermsModal: false });
          }}
          updateTermsList={() => {
            fetchTermsList(values.salesOrderId);
            setStatus({ ...status, showTermsModal: false });
          }}
          invoiceTermsList={invoiceTermsList}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
          showPrompt={showPrompt}
        />
      </CustomModal>
    );
  };

  function closeModal() {
    setStatus({
      ...status,
      showBulkAddItemsModal: false,
      showContactCreateModal: false,
      showItemModal: false,
      showCurrencyCreateModal: false,
    });
  }

  const newItemModal = () => {
    return (
      <CustomModal
        size="large"
        customWidth="item-modal-width"
        renderActions={false}
        showModal={status.showItemModal}
        title={t('Invoice.invoice_form.add_item')}
        onClose={closeModal}
        showPrompt={showPrompt}
      >
        <ItemForm
          inModal
          type="add"
          onSubmitModal={(newItem) => {
            let ItemsIndex = values.items.length - 1;
            handleCreatedItem(newItem.data, ItemsIndex);
            setStatus({
              ...status,
              showItemModal: false,
            });
          }}
          modalSource={false}
          closeModal={closeModal}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
        />
      </CustomModal>
    );
  };

  const handleCreatedItem = async (item, index) => {
    setLoadingItem(true);

    // Item's sales_unit_price is always in base currency
    const itemBasePriceFromDB = item.sales_unit_price;

    // Get current selected currency
    const selectedCurrency = baseCurrencylist.find(
      (curr) => curr.id === values.globalCurrency
    );

    // The base currency value is the item's original price
    let baseCurrencyValue = itemBasePriceFromDB;

    // Calculate unitPrice based on current currency
    let unitPrice;
    if (selectedCurrency && selectedCurrency.is_base_currency) {
      // If in base currency, use the base price directly
      unitPrice = itemBasePriceFromDB;
    } else {
      // If in foreign currency, convert base price to foreign currency
      unitPrice =
        values.exchangeRate > 0
          ? itemBasePriceFromDB * values.exchangeRate
          : itemBasePriceFromDB;
    }

    var newAddedItem = {
      id: item.id,
      salesOrderItemDetailId: null,

      dragDropID: GetDateString(),
      warehouseId: primaryWarehouse,
      name: item.name,
      images: item.images,
      sku: item.sku,
      inventoryType: item.inventory_type,
      unit: item.unit,
      ordered: 0,
      invoiced: 0,
      quantity: 1,
      unitPrice: unitPrice,
      baseCurrencyValue: baseCurrencyValue,
      discount: 0,
      discountType: 'percent',
      upc: item.upc ? item.upc : null,
      mpn: item.mpn ? item.mpn : null,
      ean: item.ean ? item.ean : null,
      isbn: item.isbn ? item.isbn : null,
      tax: {
        id: item.tax ? item?.tax?.id : null,
        rate: item.tax ? item?.tax?.rate : 0,
        name: item.tax ? item?.tax?.name : '',
      },
      taxAmount: 0,
      stocks: item.item_stocks,
    };
    status.itemsList.push(newAddedItem);
    const newItem = {
      ...newAddedItem,
      quantity: values.items[index].quantity,
      warehouseId: primaryWarehouse,
      previousSellingPrice: 0,
    };

    // Calculate total with the newItem data
    newItem.total = parseFloat(getItemTotalAmount(newItem));
    setShowAddItemButton(true);
    //let updatedNewItem = await getPreviousSellingPrice(values.contactId, newItem, status, setStatus)
    //below code run for so invoice and direct edit invoice, adds selected item to dropdown list and removes duplicated,
    if (inModal || (type === 'edit' && invoice.soId)) {
      direcInvItems = direcInvItems.filter((item1) => item1.id !== item.id);
      setStatus({
        ...status,
        itemsList: Array.from(new Set(direcInvItems.map((a) => a.id))).map(
          (id) => {
            return direcInvItems.find((a) => a.id === id);
          }
        ),
      });
      setLoadingItem(false);
    }
    setFieldValue(`items[${index}]`, { ...newItem });
    /* if (invoiceType === 'edit' && checkDirectInvoice !== false) {
      setStatus({
        ...status,
        itemsList: status.itemsList.filter(item1 =>  item1.invoiceItemDetailId !== item.invoiceItemDetailId)
      })
      return
    }
    if (item.inventoryType === "noninventory" || salesOrderId) {
      setStatus({
        ...status,
        itemsList: status.itemsList.filter(item =>  item.id !== option.id )
      })
    }*/
    setLoadingItem(false);
  };

  const contactCreateModal = () => {
    // modalflag = true;
    return (
      <CustomModal
        size="large"
        showModal={status.showContactCreateModal}
        title="Add Contact"
        customWidth="contact-modal-width"
        renderActions={false}
        onClose={closeModal}
        showPrompt={showPrompt}
      >
        <AddContact
          type="salesOrder"
          inModal
          close={closeModal}
          onSubmit={(res) => handleContactCreateSubmit(res.data)}
          handleToast={handleToast}
          handlePrompt={handlePrompt}
        />
      </CustomModal>
    );
  };
  const currencyCreateModal = () => {
    // modalflag = true;
    return (
      <CustomModal
        size="medium"
        showModal={status.showCurrencyCreateModal}
        title={t('common.addCurrency')}
        // customWidth="contact-modal-width"
        renderActions={false}
        onClose={closeModal}
        showPrompt={showPrompt}
      >
        <AddCurrency
          handleToast={handleToast}
          closeEditmodal={closeModal}
          onSubmit={(res) => handleCurrencyCreateSubmit(res?.data)}
          fromInvoice={true}

        // fetchDataWithQueryString={() => this.fetchDataWithQueryString()}
        />
      </CustomModal>
    );
  };
  const getPriceFunction = async (customerId) => {
    if (values?.items[0]?.id !== null) {
      setLoadingItem(true);
      const ids = values.items.map((item) => {
        return item.id;
      });

      const response = await getPreviousSellingPrice(
        customerId,
        ids,
        status,
        setStatus
      );
      values.items.map((newItem, index) => {
        let previousRate = response?.find((o) => o.item_id === newItem.id);
        newItem.previousSellingPrice = previousRate?.rate;
        values.items[index] = newItem;
      });
      setLoadingItem(false);
    }
  };

  const handleContactCreateSubmit = async (newCustomer) => {
    const old_obj = {
      id: newCustomer.id,
      display_name: newCustomer.display_name,
    };
    setCustomerName(newCustomer.display_name);
    const { id: value, display_name: label, ...rest } = old_obj;

    const new_customer = { value, label, ...newCustomer };

    setValues({
      ...values,
      // items: [emptyItem],
      customerId: new_customer ? new_customer.id : null,
    });

    setCurrentCustomer(new_customer);
    await getPriceFunction(new_customer.value);

    let invoiceTermFilter = new_customer.invoice_term_id
      ? invoiceTermsList.filter(
        (list) => parseInt(list.id) === parseInt(new_customer.invoice_term_id)
      )
      : [];
    invoiceTermFilter.length > 0 &&
      setFieldValue('invoiceTerm', {
        name: invoiceTermFilter[0].name,
        value: invoiceTermFilter[0].value,
      });
    invoiceTermFilter.length > 0 && handleDate(invoiceTermFilter[0]);
    closeModal();
    // const new_customer = {value, label, ...newCustomer};
    // setCurrentCustomer('new customer');
  };

  const handleBulkAddItemsOnSubmit = async (selectedItems) => {
    const ids = selectedItems.map((item) => {
      return item.id;
    });
    // // Remove first blank field when adding items in bulk
    if (values.items[0] && values.items[0].id === null) {
      values.items.shift();
    }
    const response = await getPreviousSellingPrice(
      values.customerId,
      ids,
      status,
      setStatus
    );
    setStatus({
      ...status,
      loadingItems: false,
    });

    let newItems = [];
    selectedItems.forEach((item) => {
      let previousPrice = response.find((a) => a.item_id === item.id);
      const newItem = {
        ...item,
        previousSellingBasePrice: previousPrice?.rate || 0,
        previousSellingPrice: previousPrice?.exchanged_rate || 0,
        previousSellingPriceCurrencyId: previousPrice?.currency_id || null,
        previous_exchange_rate: previousPrice?.exchange_rate || 1,
        warehouseId: primaryWarehouse,
        discount: 0,
        discountType: 'percent',
        dragDropID: GetDateString(),
        unitPrice: item.sales_unit_price * (values.exchangeRate || 1),
        total: getItemTotalAmount({
          quantity: item.quantity,
          unitPrice: item.sales_unit_price * (values.exchangeRate || 1),
        }),
      };
      newItems.push(newItem);
    });
    setValues({
      ...values,
      items: [...values.items, ...newItems],
    });
    setStatus({
      ...status,
      //itemsList: status.itemsList.filter(item => !selectedItems.find(newItem => newItem.id === item.id  && item.inventory_type !== "inventory")),
      showBulkAddItemsModal: false,
    });

    // item.warehouseId = primaryWarehouse;
    // item['dragDropID'] = GetDateString();

    // for (let option of selectedItems) {
    //   option['unitPrice'] = option.sales_unit_price;
    //   option['total'] = getItemTotalAmount({
    //     quantity: option.quantity,
    //     unitPrice: option.sales_unit_price,
    //   });
    // }

    // let promises = [];
    // selectedItems.forEach((item) => {
    //   let PPURL = null;
    //   if (values.invoiceId !== null) {
    //     PPURL = `invoice/previoussoldprice?customer_id=${values.customerId}&item_id=${item.id}&object=invoice&object_id=${values.invoiceId}`;
    //   } else {
    //     PPURL = `invoice/previoussoldprice?customer_id=${values.customerId}&item_id=${item.id}`;
    //   }
    //   promises.push(restRequest('get', PPURL));
    // });
    // Promise.all(promises).then((promisRes) => {
    //   selectedItems.forEach((item, index) => {
    //     selectedItems[index] = {
    //       ...item,
    //       previousSellingPrice: promisRes[index] ? promisRes[index] : 0,
    //       discount: 0,
    //       discountType: 'percent',
    //     };
    //   });

    document.getElementsByClassName('action-buttons--submit').disabled = false;
    // });
  };

  const [modalState, setModalstate] = useState(false);
  useEffect(() => {
    if (!status.showBulkAddItemsModal) {
      setModalstate(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status.showBulkAddItemsModal]);
  const bulkAddItemsModal = () => {
    return (
      <CustomModal
        size="large bulk"
        showModal={status.showBulkAddItemsModal}
        title={t('Invoice.invoice_form.add_bulk_item')}
        modaltitle="modal_BulkItems_title_align"
        Icon={NewItemIcon}
        renderActions={false}
        onClose={closeModal}
        handleSubmiting={modalState}
        showPrompt={showPrompt}
      >
        <BulkAddItems
          // GetAllItem={GetAllItem}
          loadingItem={loadingItem}
          // items={status.itemsList.map((item) => ({
          //   ...item,
          //   quantity: 1,
          // }))}
          rateKey="sales_unit_price"
          currencySymbol={currency?.symbol}
          close={closeModal}
          onSubmit={handleBulkAddItemsOnSubmit}
          handleToast={handleToast}
          setModalstate={setModalstate}
          handlePrompt={handlePrompt}
          moduleName="invoices"
        />
      </CustomModal>
    );
  };

  const closeConfirmedSalesOrdersListModal = () => {
    setStatus({ ...status, showConfirmedSalesOrdersListModal: false });
    updateconfirmedSO(0);
  };

  const [loader, showLoader] = useState(false);
  const handleConfirmedSalesOrdersListOnSubmit = async (
    selectedConfirmedSalesOrdersList
  ) => {
    showLoader(true);
    // Remove first blank field when adding items in bulk
    if (values.items[0] && values.items[0].id === null) {
      values.items.shift();
    }
    let ModifiedselectedConfirmedSalesOrdersList =
      selectedConfirmedSalesOrdersList.map((salesOrder) => {
        let newSalesOrderList = salesOrder.sales_order_item_details.filter(
          (singleItem) => singleItem.hasItemAdded !== true
        );
        return {
          ...salesOrder,
          sales_order_item_details: newSalesOrderList,
        };
      });
    const { items, selectedSalesOrderIds } = prepareConfirmedSalesOrdersItems(
      // selectedConfirmedSalesOrdersList
      ModifiedselectedConfirmedSalesOrdersList
    );
    let modifiedConfirmSalesOrderList = status.confirmedSalesOrdersList;
    // if (items.length) {
    //   setConfirmedSaleOrderSelected(true);
    // }
    items.forEach((singleItem) => {
      modifiedConfirmSalesOrderList = modifiedConfirmSalesOrderList.map(
        (singleOrder) => {
          if (singleItem.currentSalesOrderId === singleOrder.id) {
            let modifiedItem = singleOrder.sales_order_item_details.map(
              (currentSingleItem) => {
                if (singleItem.id === currentSingleItem.item_id) {
                  return {
                    ...currentSingleItem,
                    hasItemAdded: true,
                  };
                } else {
                  return currentSingleItem;
                }
              }
            );
            return {
              ...singleOrder,
              sales_order_item_details: modifiedItem,
            };
          } else {
            return singleOrder;
          }
        }
      );
    });

    const ids = items.map((item) => {
      return item.id;
    });

    const response = await getPreviousSellingPrice(
      values.customerId,
      ids,
      status,
      setStatus
    );
    setStatus({
      ...status,
      loadingItems: false,
    });
    let newItems = [];
    items.forEach((item) => {
      let previousPrice = response.find((a) => a.item_id === item.id);
      const newItem = {
        ...item,
        // previousSellingPrice: previousPrice?.rate || null,
        previousSellingBasePrice: previousPrice?.rate || 1,
        previousSellingPrice: previousPrice?.exchanged_rate || 1,
        previousSellingPriceCurrencyId: previousPrice?.currency_id || null,
        previous_exchange_rate: previousPrice?.exchange_rate || 1,
        dragDropID: GetDateString(),
      };
      newItems.push(newItem);
    });

    let modifiedselectedConfirmedSalesOrderIds = [
      ...status.selectedConfirmedSalesOrderIds,
      ...selectedSalesOrderIds,
    ];
    modifiedConfirmSalesOrderList = modifiedConfirmSalesOrderList.map(
      (salesOrder) => ({
        ...salesOrder,
        selectedByItem: modifiedselectedConfirmedSalesOrderIds.includes(
          salesOrder.id
        ),
      })
    );

    setStatus({
      ...status,
      confirmedSalesOrdersList: modifiedConfirmSalesOrderList,
      selectedConfirmedSalesOrderIds: modifiedselectedConfirmedSalesOrderIds,
      showConfirmedSalesOrdersListModal: false,
    });
    showLoader(false);

    setFieldValue('items', [...values.items, ...newItems]);
  };

  const confirmedSalesOrdersListModal = () => {
    return (
      <CustomModal
        showModal={status.showConfirmedSalesOrdersListModal}
        title={
          confirmedSO !== 0
            ? `${t('Invoice.confirm_so_modal')} (${confirmedSO} ${t(
              'Invoice.selected'
            )})`
            : t('Invoice.confirm_so_modal')
        }
        renderActions={false}
        Icon={NewSalesOrderIcon}
        modaltitle="confirm_SO_modal"
        onClose={() => closeConfirmedSalesOrdersListModal()}
      >
        <BulkAddConfirmedSalesOrders
          salesOrdersList={status?.confirmedSalesOrdersList.filter(
            (item) => item?.selectedByItem !== true
          )}
          onSubmit={(selectedConfirmedSalesOrdersList) => {
            // selectedConfirmedSalesOrdersList &&
            //   confirmedSaleOrderSelected(true);
            handleConfirmedSalesOrdersListOnSubmit(
              selectedConfirmedSalesOrdersList
            );
          }}
          handleToast={handleToast}
          onClose={() => closeConfirmedSalesOrdersListModal()}
          updateconfirmedSO={updateconfirmedSO}
          loader={loader}
        />
      </CustomModal>
    );
  };
  const getSalesPersonData = (id) => {
    // console.log(id, "id")
    const selected = salesPersonsFromDB
      .map((sp) => sp.users || sp)
      .find((p) => p.id === id);

    return {
      id: selected?.id || null,
      user_id: selected?.user_id || null,
    };
  };
  const handleCustomerChange = async (option) => {
    // console.log(option, 'option');
    const salesManagerId = option?.sales_person_id
      ? option.sales_person_id      // option exists
      : invoice.current_user_id;
    // console.log('option', invoice.current_user_id);
    const { selectedConfirmedSalesOrderIds = [] } = status;
    if (selectedConfirmedSalesOrderIds.length > 0) {
      setShowConfirmRemoveItemModal(true);
      setStatus({
        ...status,
        newCustomerId: option?.value,


      });

      return;
    }
    if (option && option.value === 'createNew') {
      setStatus({ ...status, showContactCreateModal: true });
      setValues({
        ...values,
      });
    } else {
      if (option && values.items[0].id !== null) {
        const ids = values.items.map((item) => {
          return item.id;
        });
        setCustomerName(option?.label);

        values.customerId = option?.value;
        // values.salesPersonId = option?.sales_person_id || null;
        // setValues({
        //   ...values,
        // });
        const response = await getPreviousSellingPrice(
          values.customerId,
          ids,
          status,
          setStatus
        );
        status.loadingItems = false;
        // setStatus({
        //   ...status,
        // });
        const safeResponse = response || [];

        let newItems = [];
        // console.log('response', response, values.items);

        values.items.forEach((item) => {
          let previousPrice = response
            ? response.find((a) => a.item_id === item.id)
            : null;
          const newItem = {
            ...item,
            previousSellingPrice: previousPrice?.rate || null,
            previous_exchange_rate: item?.exchange_rate || 1,
            dragDropID: GetDateString(),
            unitPrice: item.sales_unit_price,
            total: getItemTotalAmount({
              quantity: item.quantity,
              unitPrice: item.sales_unit_price,
            }),
          };
          newItems.push(newItem);
        });
        // console.log(invoice.salesPersonId, salesPersonsFromDB, invoice, show_sales_person_all_records, is_sales_person);

        // fallback to current user
        let salesPersonId = null;
        let salesPersonUserId = null;
        if (is_sales_person === "sales_manager") {

          const data = getSalesPersonData(option?.sales_person_id || salesManagerId);
          salesPersonId = data.id;
          salesPersonUserId = data.user_id;

        } else if (is_sales_person === true) {

          if (show_sales_person_all_records) {
            const data = getSalesPersonData(
              option?.sales_person_id || invoice?.salesPersonId
            );

            salesPersonId = data.id;
            salesPersonUserId = data.user_id;

          } else {
            const data = getSalesPersonData(
              invoice?.salesPersonId
            );
            // console.log('data', data)
            salesPersonId = data.id;
            salesPersonUserId = data.user_id;
          }

        } else {
          salesPersonId = option?.sales_person_id;
          salesPersonUserId = null;
        }
        setValues({
          ...values,


          salesPersonId: salesPersonId,
          // : option?.sales_person_id
          //   ? option.sales_person_id
          //   : is_sales_person === "sales_manager"
          //     ? salesManagerId
          //     : is_sales_person === true && show_sales_person_all_records === true
          //       ? (invoice.salesPersonId || null)
          //       : null,
          items: newItems,
        });
      } else {
        setCustomerName(option?.label);
        // console.log("nope", is_sales_person)
        // console.log("2")

        let salesPersonId = null;
        let salesPersonUserId = null;

        if (is_sales_person === "sales_manager") {

          const data = getSalesPersonData(option?.sales_person_id || salesManagerId);
          // console.log('data', data)
          salesPersonId = data.id;
          salesPersonUserId = data.user_id;

        } else if (is_sales_person === true) {

          if (show_sales_person_all_records) {
            const data = getSalesPersonData(
              option?.sales_person_id || invoice?.salesPersonId
            );

            salesPersonId = data.id;
            salesPersonUserId = data.user_id;

          } else {
            // console.log("nope", option?.sales_person_id, salesManagerId, invoice?.salesPersonId, show_sales_person_all_records)
            const data = getSalesPersonData(
              invoice?.salesPersonId
            );
            // console.log('data', data)

            salesPersonId = data.id;
            salesPersonUserId = data.user_id;
          }

        } else {
          // console.log('data')

          salesPersonId = option?.sales_person_id;
          salesPersonUserId = null;
        }
        setValues({
          ...values,
          customerId: option ? option?.value : null,
          salesPersonId: salesPersonId
        });
        setStatus({
          ...status,
          confirmedSalesOrdersList: [],
        });
      }
      // console.log('5', values);
      // when customer has custom invoice term ---> enable due date field
      const { value: invoiceTermValue } = option?.invoice_terms || {};
      if (option?.invoice_terms) setTerms_condition(invoiceTermValue);
      if (option) fetchConfirmedSalesOrders(option?.value, invoiceTermValue);
    }
  };

  const fetchConfirmedSalesOrders = (customerId, invoiceTermValue) => {
    setSales_invoice_loading(true);
    restRequest(
      'get',
      `invoices/create/invoiceable-confirmed-salesorders/from-contacts/${customerId}`
    ).then((res) => {
      setSales_invoice_loading(false);
      setStatus({
        ...status,
        confirmedSalesOrdersList: res.sale_orders,
        selectedConfirmedSalesOrderIds: [],
        disableDate: invoiceTermValue === 'custom' ? false : true,
      });
      setFieldValue('invoiceTerm', {
        name:
          res.customer[0] &&
          res.customer[0].invoice_terms &&
          res.customer[0].invoice_terms.name,
        value:
          res.customer[0] &&
          res.customer[0].invoice_terms &&
          res.customer[0].invoice_terms.value,
      });
      handleDate(
        res.customer[0] &&
        res.customer[0].invoice_terms &&
        res.customer[0].invoice_terms
      );
    });
  };

  const mergeItems = (event) => {
    if (submitFlag === false) {
      event.preventDefault();
      setShowMergeModal(true);
    } else {
      formSubmit(event, values.items, setFieldValue, handleSubmit);
    }
  };

  const renderAddItem = () => {
    return (
      <>
        {showAddItemButton && (
          <AddItem
            onClick={() =>
              setValues({
                ...values,
                items: [...values.items, status.emptyItem],
              })
            }
          />
        )}
        {values.customerId && !checkDirectInvoice && !inModal && (
          <AddItem
            label={t('Invoice.invoice_form.add_bulk_item')}
            onClick={() =>
              !loadingItem &&
              setStatus({
                ...status,
                showBulkAddItemsModal: true,
              })
            }
          />
        )}
      </>
    );
    // }
  };


  const handleSalesPersonChange = (option) => {
    // console.log(option, 'selected sales person');
    if (option !== null) {
      setFieldValue('salesPersonId', option.value);
    } else {
      setFieldValue('salesPersonId', null);
    }
  };

  const handleTermsAndConditions = (event) => {
    let selectedValue = event.target.value;
    // FieldValueChanged();
    if (selectedValue === 'true') {
      setFieldValue('hasTermsAndConditions', !!selectedValue);
    } else {
      setFieldValue('hasTermsAndConditions', !!!selectedValue);
    }
  };

  const renderTermsAndConditions = () => {
    return (
      <div className="form-field flex-50">
        <Field
          className="radio-field radio_buttons"
          type="radio"
          labelStyle={true}
          name={t('Invoice.invoice_form.termsAndConditions')}
          id="yes"
        >
          <RadioContainer>
            <Radio
              className="inline-field "
              id="yes"
              value={true}
              name={t('Invoice.invoice_form.yes')}
              onChange={handleTermsAndConditions}
              checked={values.hasTermsAndConditions}
            />
            <Radio
              className="inline-field"
              id="no"
              value={false}
              name={t('Invoice.invoice_form.no')}
              onChange={handleTermsAndConditions}
              checked={!values.hasTermsAndConditions}
            />
          </RadioContainer>
        </Field>
        <div className="invoice-textarea-height">
          {values.hasTermsAndConditions && (
            <Field
              className="textarea-so-terms w-100"
              type="textarea"
              value={
                values.termsAndConditions !== null
                  ? values.termsAndConditions
                  : ''
              }
              id="termsAndConditions"
              required={true}
              handleChange={(e) => {
                setFieldValue('termsAndConditions', e.target.value);
              }}
              error={touched.termsAndConditions && errors.termsAndConditions}
            />
          )}
        </div>
      </div>
    );
  };

  let submitFlag = true;
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showPendInvModal, setShowPendInvModal] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [customerId, setCustomerId] = useState('');
  const handleCustomerModal = (id) => {
    setCustomerId(id);
    setShowCustomerModal(true);
  };

  const handleDetailModal = (id) => {
    setCustomerId(id);
    setShowPendInvModal(true);
  };
  const handlePrompt = (status = true) => setShowPrompt(status);

  const contactDeatilModal = () => {
    return (
      <CustomModal
        size="large"
        className="contacts_modal_view"
        showModal={showCustomerModal}
        title={t('Invoice.view_contact')}
        // minWidth={120}
        modaltitle="inventory_modal_title"
        Icon={NewContactIcon}
        renderActions={false}
        onClose={() => setShowCustomerModal(false)}
        linkTo={`contacts/${customerId && customerId}`}
      >
        <Customer id={customerId && customerId} inModal />
      </CustomModal>
    );
  };

  const pendingInvoiceModal = () => {
    return (
      <CustomModal
        size="large"
        className="view_pending_popup"
        showModal={showPendInvModal}
        title={`${t(
          'Invoice.invoice_form.pending_invoices'
        )} - ${customerName}`}
        // minWidth={120}
        modaltitle="inventory_modal_title"
        Icon={NewInvoiceIcon}
        renderActions={false}
        onClose={() => setShowPendInvModal(false)}
      >
        <TableContent
          url={`invoices/unpaid/${customerId}`}
          inModal={true}
          showdetail="Invoices"
          currency={currency?.symbol}
        />
      </CustomModal>
    );
  };

  const checkTotalValueForZero = () => {
    return (
      <CustomModal
        style={{ marginTop: '5%' }}
        showModal={cofirmState}
        title={t('Invoice.invoice_form.confirm_invoice')}
        renderActions={false}
        onClose={() => handleTotalCheckFalse(false)}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <p>{t('Invoice.invoice_form.confirm_invoice_msg')}</p>

          <button
            type="button"
            className="action-buttons--submit next-btn"
            onClick={() => {
              handleTotalCheckFalse(false);
              totalConfirmCheck = true;
              handleSubmit();
            }}
          >
            {t('Invoice.invoice_form.confirm')}
          </button>
        </div>
      </CustomModal>
    );
  };

  const ReasonOnEdit = ({
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  }) => {
    return (
      <CustomModal
        size="medium"
        showModal={confirmOnEdit}
        //title=""
        title={t('Invoice.invoice_form.reason_for_edit')}
        renderActions={false}
        onClose={() => {
          setFieldValue('edit_reason', ''); // This will clear the field

          handleReasonOnEdit(false);
        }}
      >
        <div className="form-field flex-100">
          <div className="invoice-edit-reason">
            <Field
              type="textarea"
              //autoFocus={true}
              name={t('Invoice.invoice_form.edit_reason_text')}
              className="invoice-edit-reason-text-area"
              id="edit_reason"
              onBlur={handleBlur}
              value={values.edit_reason}
              handleChange={handleChange}
              error={errors.edit_reason}
            />
          </div>
        </div>
        <div className="btnsRow">
          <button
            type="button"
            className="cancel-btn mr-3"
            onClick={() => {
              setFieldValue('edit_reason', ''); // This will clear the field

              handleReasonOnEdit(false);
            }}
          >
            {t('Invoice.invoice_form.cancel')}
          </button>
          <button
            type="button"
            className="action-buttons--submit next-btn"
            disabled={!values?.edit_reason?.trim() || errors.edit_reason}
            onClick={() => {
              if (errors.edit_reason) {
                return;
              }
              handleReasonOnEdit(false);
              confirmModal = true;
              handleSubmit();
            }}
          >
            {t('Invoice.invoice_form.confirm')}
          </button>
        </div>
      </CustomModal>
    );
  };
  const handleDeleteConfirmSaleOrderItems = () => {
    let { items = [] } = values;

    let { selectedConfirmedSalesOrderIds = [], newCustomerId } = status;

    const itemResult = items.filter(
      (item) =>
        selectedConfirmedSalesOrderIds.indexOf(item.currentSalesOrderId) === -1
    );
    if (newCustomerId) {
      fetchConfirmedSalesOrders(newCustomerId, terms_condition);
    }
    if (!itemResult.length) {
      setStatus({
        ...status,
        confirmedSalesOrdersList: [],
        selectedConfirmedSalesOrderIds: [],
      });
    }

    setFieldValue(
      'items',
      itemResult?.length ? itemResult : [status.emptyItem]
    );
    setFieldValue('customerId', newCustomerId);

    setShowConfirmRemoveItemModal(false);
  };
  const renderConfirmRemoveItemModal = () => {
    const { items = [] } = values;
    const salesOrderitemList = items.filter((item) => item.id);
    return (
      <>
        <CustomModal
          showModal={showConfirmRemoveItemModal}
          title={t('Invoice.invoice_form.confirm_delete')}
          onClose={() => {
            setShowConfirmRemoveItemModal(false);
          }}
          onSubmit={handleDeleteConfirmSaleOrderItems}
        >
          <div className="confirm-popup-main">
            <p>{t('Invoice.invoice_form.item_confirm_delete')}</p>
            <>
              <ul className="confirm-popup">
                {salesOrderitemList.map((saleOrderitem) => (
                  <li key={saleOrderitem.id}>{saleOrderitem.name}</li>
                ))}
              </ul>
            </>
          </div>
        </CustomModal>
      </>
    );
  };

  const handleDueDate = (option, invoiceStartDate) => {
    let value = option.value;
    let date = invoiceStartDate;
    switch (value) {
      case 'custom':
        break;
      case 'this month':
        date = moment(customRanges(invoiceStartDate).endOfMonth);
        break;
      case 'next month':
        date = moment(customRanges(invoiceStartDate).endOfNextMonth);
        break;
      case 'receipt':
        date = moment(customRanges(invoiceStartDate).endOfToday);
        break;
      default:
        date = moment(addDays(invoiceStartDate, value));
    }
    setFieldValue('dueDate', date);
  };
  const showAddItemsButton = () => {
    if (type === 'add') {
      return true;
    } else if (type === 'edit') {
      if (values?.status === 'draft') {
        return true;
      } else if (!owner_can_edit_in_lock_status) {
        return false;
      }
    }
  };

  const debouncedSetRate = useMemo(
    () =>
      debounce((rate) => {
        if (rate < 0.0000000001) rate = 1;
        if (rate > 9999) rate = 9999;
        setFieldValue('exchangeRate', rate);
      }, 500),
    [setFieldValue]
  );
  return (
    <Fragment>
      {contactCreateModal()}
      {newItemModal()}
      {invoiceTermModal()}
      {bulkAddItemsModal()}
      {confirmedSalesOrdersListModal()}
      {contactDeatilModal()}
      {checkTotalValueForZero()}
      {renderConfirmRemoveItemModal()}
      {pendingInvoiceModal()}
      {currencyCreateModal()}

      <Form
        className={` invoice_form_main invoice-popup-main  ${inModal ? 'invoice_modal invoices-large' : 'uiux-invoice-form-main'
          }`}
        title={title}
        onSubmit={(event) => mergeItems(event)}
      >
        {ReasonOnEdit({
          values,
          touched,
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        })}
        <div className="form-fields-container d-flex flex-wrap uiux-invoice-form w-100 ">
          <div className="field-container  position-relative flex-25 form-field">
            <Field
              id="customerId"
              name={t('Invoice.invoice_form.customerName')}
              placeholder={t('Invoice.invoice_form.selectCustomer')}
              autoFocus={true}
              type="DynamicPaginationDropdown"
              newCust={CurrentCustomer}
              value={values.customerId}
              editCust={values.invoiceObj}
              disabled={
                owner_can_edit_in_lock_status ||
                inModal ||
                (type === 'edit' && invoice.soId) ||
                temporary_edit
              }
              addButton={true}
              required
              handleChange={(option) => {
                handleCustomerChange(option);
              }}
              error={touched.customerId && errors.customerId}
              alphabetSort={true}
              onBlur={() => {
                setFieldTouched('customerId', true);
              }}
              api="invoices/contact"
            />
            {!inModal && values.customerId && (
              <div className="details-sec text-left d-flex space-between">
                <button
                  type="button"
                  className="view-details-btn-1 pt-8"
                  onClick={() => handleDetailModal(values.customerId)}
                >
                  {' '}
                  {t('Invoice.invoice_form.pending_invoices')}
                </button>

                <div className="details-sec text-right">
                  <button
                    type="button"
                    className="view-details-btn-1 pt-8"
                    onClick={() => handleCustomerModal(values.customerId)}
                  >
                    {' '}
                    {t('saleOrder.view_details')}
                  </button>
                </div>
              </div>
            )}
          </div>
          <Field
            name={t('Invoice.invoice_form.invoiceNo')}
            id="invoiceNo"
            className="flex-25"
            placeholder={t('Invoice.invoice_form.invoiceNo')}
            value={values.invoiceNo}
            // disabled={ type === 'edit'}
            disabled
            handleChange={handleChange}
            onBlur={handleBlur}
            required
            error={touched.invoiceNo && errors.invoiceNo}
          />
          <Field
            name={t('Invoice.invoice_form.orderNo')}
            id="orderNo"
            className={` flex-25 position-relative ${!inModal && values.customerId
              ? 'invoice-form-details'
              : 'invoice-add-form'
              }`}
            // className="flex-25 position-relative invoice-add-form"
            value={values.orderNo === null ? '' : values.orderNo}
            handleChange={handleChange}
            onBlur={handleBlur}
            disabled={inModal}
            error={touched.orderNo && errors.orderNo}
          />

          <Field
            className="flex-25 date-canalder-g"
            type="date"
            name={t('Invoice.invoice_form.invoiceDate')}
            id="invoiceDate"
            disabled={owner_can_edit_in_lock_status || temporary_edit}
            // value={values.invoiceDate}
            value={
              typeof values.invoiceDate == 'string'
                ? moment(values.invoiceDate)
                : values.invoiceDate
            }
            // minDate={values.saleOrderDate}
            minDate={
              typeof values.saleOrderDate == 'string'
                ? moment(values.saleOrderDate)
                : values.saleOrderDate
            }
            handleChange={(date) => {
              if (!date) return;
              setFieldValue('invoiceDate', date);
              if (
                values.invoiceTerm.name === '' ||
                values.invoiceTerm.name === 'custom'
              ) {
                if (values.dueDate < date) {
                  setFieldValue('dueDate', date);
                }
              } else {
                handleDueDate(values.invoiceTerm, date);
              }
            }}
            onBlur={() => setFieldTouched('invoiceDate', true)}
            required
            error={touched.invoiceDate && errors.invoiceDate}
          />

          <InvoiceTerm
            className="flex-25"
            name={t('Invoice.invoice_form.invoice_terms')}
            handleInvoiceTerms={(option) => handleInvoiceTerms(option)}
            handleInvoiceDate={(date) => setFieldValue('dueDate', date)}
            invoiceDate={values.invoiceDate}
            invoiceTermsList={invoiceTermsList}
            selectedInvoiceTerm={values.invoiceTerm}
            owner_can_edit_in_lock_status={
              owner_can_edit_in_lock_status || temporary_edit
            }
          />

          <Field
            type="date"
            name={t('Invoice.invoice_form.dueDate')}
            className="flex-25"
            id="dueDate"
            minDate={values.invoiceDate}
            value={values.dueDate}
            handleChange={(date) => setFieldValue('dueDate', date)}
            disabled={status.disableDate || temporary_edit}
          />
          {!!salesPersonsFromDB && (
            <Field
              type="dropdown"
              id="salesPersonId"
              name={
                <>
                  {t('Invoice.invoice_form.salesPerson')}
                  {invoice.salesPersonPlatform === 'books' && (
                    <ToolTip content="Sales person origin is BMS" />
                  )}
                </>
              }
              className="flex-25"
              value={values.salesPersonId}
              options={salesPersonsFromDB.map(
                (salesPerson) => {
                  return salesPerson.users || salesPerson;
                }
              )}
              // disabled={
              //   is_sales_person || invoice.salesPersonPlatform === 'books'
              // }
              disabled={is_sales_person === true && !show_sales_person_all_records || invoice.salesPersonPlatform === 'books'}

              dropdownValue="id"
              dropdownLabel="name"
              handleChange={handleSalesPersonChange}
              clearable={sales_person_clearable}
            />
          )}

          <div className="d-flex w-100 tablet-align flex-wrap invoice-tbl">
            <Field
              type="textarea"
              className="flex-50"
              name={t('Invoice.invoice_form.notes')}
              value={values.note}
              id="note"
              handleChange={handleChange}
              onBlur={handleBlur}
              error={touched.note && errors.note}
            />
            {renderTermsAndConditions()}
          </div>
          {
            <>
              <Field
                size="large"
                name={t('Settings.currency')}
                id="globalCurrency"
                value={values.globalCurrency || null}
                options={currencyList}
                dropdownValue="value"
                dropdownLabel="label"
                className="flex-25"
                addButton={permissions?.superAccess ? true : false}
                disabled={
                  isSaleOrderSelected ||
                  !permissions?.superAccess ||
                  salesOrderId ||
                  temporary_edit
                }
                handleChange={(option) => {
                  if (option && option.value === 'createNew') {
                    setStatus({ ...status, showCurrencyCreateModal: true });
                    // setShowCurrencyModal(true);
                    return;
                  }
                  if (option?.value === values.globalCurrency) {
                    return;
                  }
                  let currentExchangeRate = 0.1;
                  if (type === 'add') {
                    currentExchangeRate = option.exchange_rate;
                  } else {
                    currentExchangeRate =
                      option?.value === invoice.globalCurrency
                        ? invoice.exchangeRate
                        : option.exchange_rate;
                  }
                  setFieldValue('globalCurrency', option?.value);
                  setFieldValue('exchangeRate', currentExchangeRate);
                }}
                onBlur={() => setFieldTouched('currencyId', true)}
                type="dropdown"
                // disabled={type === 'edit'}
                clearable={false}
                required
                error={touched.currencyId && errors.name}
              />

              {isSaleOrderSelected && (
                <div className="align-tooltip">
                  <ToolTip
                    placement="top"
                    content={t('Invoice.currency_not_change_msg')}
                  >
                    <MdHelpOutline
                      className="material-icon blue-icon help"
                      style={{ marginRight: '1.7rem' }}
                    />
                  </ToolTip>
                </div>
              )}
            </>
          }
          {values.globalCurrency && currency.id !== values.globalCurrency && (
            <Field
              name={t('Settings.exchange_rate')}
              className="float-right bold"
              type="number"
              value={
                // getcurrencysymble() +
                parseFloat(values?.exchangeRate)
              }
              disabled={
                isSaleOrderSelected || !permissions?.superAccess || salesOrderId
              }
              decimalScale={6}
              allowNegative
              id="exchangeRate"
              prefix={getcurrencysymble()}
              placeholder={getcurrencysymble() + '1'}
              thousandSeparator=","
              onValueChange={(value) => {
                debouncedSetRate(value.floatValue);
              }}
              onBlur={handleBlur}
              error={touched?.exchangeRate && errors?.exchangeRate}
            />
          )}

          {values.globalCurrency &&
            currency?.id === values.globalCurrency &&
            currency?.is_base_currency && (
              <div
                style={{ display: 'flex', alignItems: 'center' }}
                className="float-right bold"
              >
                <span
                  class="badge badge-success"
                  style={{ backgroundColor: '#a8e6a1', color: 'black' }}
                >
                  {' '}
                  {t('common.baseCurrency')}
                </span>
              </div>
            )}

          {values.globalCurrency !== currency?.id && (
            <CurrencyRateTiles
              currentCurrency={currentCurrency}
              setFieldValue={setFieldValue}
              currency={currency}
              values={values}
            />
          )}
        </div>
        {
          <p className="feature-note">
            <strong>Caution:&nbsp;</strong>Changing the <b>Currency</b> or{' '}
            <b>Exchange Rate</b> will trigger recalculations for all related
            amount fields. Please review and verify them again.
          </p>
        }
        <div className="form-field form-table--container horizontal-items-table invoice-table-set">
          <label className="form-label">
            {t('Invoice.invoice_form.label')}
          </label>
          {loadingItem && <Loader />}
          <FieldArray
            name="items"
            render={() => renderSelectedItemsTable(type)}
          />
          {showAddItemsButton() && (
            <div className="invoice-form-items-action">
              {type === 'add' && salesOrderId === null
                ? renderAddItem()
                : showAddItemButton && renderAddItem()}

              {type === 'add' && (
                <>
                  {values.globalCurrency !== currency.id ? (
                    <ToolTip content={t('Invoice.confirm_orders_msg')}>
                      <AddItem
                        // visible={!!status.confirmedSalesOrdersList.length}
                        visible={
                          status.confirmedSalesOrdersList.filter(
                            (item) => item?.selectedByItem !== true
                          ).length
                        }
                        onClick={() =>
                          setStatus({
                            ...status,
                            showConfirmedSalesOrdersListModal: true,
                          })
                        }
                        disabled={values.globalCurrency !== currency.id}
                        label={
                          sales_invoice_loading
                            ? t('Invoice.invoice_form.loading')
                            : `${t('Invoice.add')} ${status.confirmedSalesOrdersList.filter(
                              (item) => item?.selectedByItem !== true
                            ).length
                            } ${t('Invoice.confirm_so')}`
                        }
                        inline={false}
                      />
                    </ToolTip>
                  ) : (
                    <AddItem
                      // visible={!!status.confirmedSalesOrdersList.length}
                      visible={
                        status.confirmedSalesOrdersList.filter(
                          (item) => item?.selectedByItem !== true
                        ).length
                      }
                      onClick={() =>
                        setStatus({
                          ...status,
                          showConfirmedSalesOrdersListModal: true,
                        })
                      }
                      disabled={values.globalCurrency !== currency.id}
                      label={
                        sales_invoice_loading
                          ? t('Invoice.invoice_form.loading')
                          : `${t('Invoice.add')} ${status.confirmedSalesOrdersList.filter(
                            (item) => item?.selectedByItem !== true
                          ).length
                          } ${t('Invoice.confirm_so')}`
                      }
                      inline={false}
                    />
                  )}
                </>
              )}
            </div>
          )}
          {renderOrderSummary()}
        </div>

        {renderActionButtons()}
        <PDFViewer showPDF={showPDF} pdf={pdf} hidePDFModal={hidePDFModal} />
        <ErrorFocus />
      </Form>
    </Fragment>
  );
};

const getOrderTotal = (values, overAllTotalTax) => {
  const {
    items,
    transactionDiscount = 0,
    transactionDiscountType,
    adjustment = 0,
    shippingCharge = 0,
  } = values;
  let overallTotal = items.reduce((total, item) => {
    return parseFloat(item.total) + parseFloat(total);
  }, 0);
  let transactionDiscountTotal = transactionDiscount;
  let TotalTax = overAllTotalTax();
  if (transactionDiscountType === 'percent') {
    if (transactionDiscount > 100) {
      return 'MAX_PERCENTAGE';
    }
    transactionDiscountTotal = (overallTotal * transactionDiscountTotal) / 100;
  } else if (transactionDiscountType === 'amount') {
    let OrderAmount = parseFloat(
      overallTotal + TotalTax + adjustment + shippingCharge
    );
    if (OrderAmount < transactionDiscount) {
      return 'MAX_AMOUNT';
    }
  }

  // console.log('total without tax -- ', overallTotal);
  // console.log('TotalTax -- ', TotalTax);
  overallTotal =
    overallTotal +
    +adjustment +
    shippingCharge -
    transactionDiscountTotal +
    TotalTax || 0;

  // console.log('overallTotal -- ', overallTotal);
  // console.log("baseTotal ", overallTotal / values.exchangeRate);
  return overallTotal;
};

export default formEnhancer(InvoiceForm);

export const CurrencyRateTiles = ({
  currentCurrency,
  setFieldValue,
  currency,
  values,
}) => {
  let permissions = getObjFromLS('role').permissions;

  return (
    <table className="currency-table">
      <thead>
        <tr>
          <th></th>
          <th>{currency?.currency_code}</th>
          <th></th>
          <th>{currentCurrency?.currency_code}</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {/* System Rate Row */}
        <tr>
          <td className="text-muted">{t('common.systemRate')}</td>
          <td>
            {currency?.symbol}&nbsp;
            {currency?.exchange_rate.toFixed(2)}
          </td>
          <td>=</td>
          <td>
            <span>{currentCurrency?.symbol}</span>&nbsp;
            <span dir="ltr">{currentCurrency?.exchange_rate.toFixed(2)}</span>
          </td>
          {permissions?.superAccess && (
            <td>
              <button
                type="button"
                className="use-currency"
                disabled={
                  parseFloat(values.exchangeRate)?.toFixed(2) ===
                  parseFloat(currentCurrency?.exchange_rate)?.toFixed(2)
                }
                onClick={() => {
                  setFieldValue('exchangeRate', currentCurrency?.exchange_rate);
                }}
              >
                {t('common.use')}
              </button>
            </td>
          )}
        </tr>

        {/* Last Invoiced Row */}
        <tr>
          <td className="text-muted">{t('common.lastInvoiced')}</td>
          <td>
            {currentCurrency?.previous_exchange_rate > 0 ? (
              <>
                {currency?.symbol}&nbsp;
                {currency?.exchange_rate.toFixed(2)}
              </>
            ) : (
              '-'
            )}
          </td>
          <td>=</td>
          <td>
            {currentCurrency?.previous_exchange_rate > 0 ? (
              <>
                <span>{currentCurrency?.symbol}</span>&nbsp;
                <span dir="ltr">
                  {currentCurrency?.previous_exchange_rate.toFixed(2)}
                </span>
              </>
            ) : (
              <span dir="ltr">{'-'}</span>
            )}
          </td>
          {permissions?.superAccess &&
            currentCurrency?.previous_exchange_rate > 0 && (
              <td>
                <button
                  type="button"
                  className="use-currency"
                  disabled={
                    parseFloat(values.exchangeRate)?.toFixed(2) ===
                    parseFloat(
                      currentCurrency?.previous_exchange_rate
                    )?.toFixed(2)
                  }
                  onClick={() => {
                    setFieldValue(
                      'exchangeRate',
                      currentCurrency?.previous_exchange_rate
                    );
                  }}
                >
                  {t('common.use')}
                </button>
              </td>
            )}
        </tr>
        {/* Live Exchange Rate Invoiced Row */}
        <tr>
          <td className="text-muted">{t('common.onlineRate')}</td>
          <td>
            {currentCurrency?.latest_exchange_rate > 0 ? (
              <>
                {currency?.symbol}&nbsp;
                {currency?.exchange_rate.toFixed(2)}
              </>
            ) : (
              '-'
            )}
          </td>
          <td>=</td>
          <td>
            {currentCurrency?.latest_exchange_rate > 0 ? (
              <>
                <span>{currentCurrency?.symbol}</span>&nbsp;
                <span dir="ltr">
                  {currentCurrency?.latest_exchange_rate.toFixed(2)}
                </span>
              </>
            ) : (
              <span dir="ltr">{'-'}</span>
            )}
          </td>
          {permissions?.superAccess &&
            currentCurrency?.latest_exchange_rate > 0 && (
              <td>
                <button
                  type="button"
                  className="use-currency"
                  disabled={
                    parseFloat(values.exchangeRate)?.toFixed(2) ==
                    parseFloat(currentCurrency?.latest_exchange_rate)?.toFixed(
                      2
                    )
                  }
                  onClick={() => {
                    setFieldValue(
                      'exchangeRate',
                      currentCurrency?.latest_exchange_rate
                    );
                  }}
                >
                  {t('common.use')}
                </button>
              </td>
            )}
        </tr>
      </tbody>
    </table>
  );
};
